/* ══════════════════════════════════════════════════════════════════════════════
   MENTA — assets/menta.js
   ══════════════════════════════════════════════════════════════════════════════
   DE ENIGE SITEWIDE JS-LAAG. Loaded ONCE in theme.liquid, on every page.

   REGEL VAN DEZE FILE: net als menta.css draagt elke surface ZERO eigen JS. Deze
   file initialiseert elk interactief mechanisme door de DOM te scannen op
   data-attributen. Een surface hoeft alleen de juiste markup te plaatsen; de JS
   pakt 'm vanzelf op. Niets hier is aan één pagina gebonden.

   VIER MECHANISMEN (allemaal data-attribuut-gedreven, allemaal guarded):
     1 · HERO fade-carousel   → [data-mnt-hero]     (cross-fade .on, autoplay 7s)
     2 · RAIL / peek carousel → [data-mnt-rail]     (translateX track, dots, 5s)
     3 · ACCORDEON            → .mnt-ac / .ac        (class-based; <details> = native)
     4 · SCROLL-REVEAL        → [data-rv] / .rv      (met verplicht vangnet)

   Plain ES5-ish vanilla JS, geen build-stap, in één IIFE. Alles guarded: een
   ontbrekend element mag NOOIT throwen, want dan sterft de hele file en elke
   surface eronder. Veilig om sitewide te laden.
   ══════════════════════════════════════════════════════════════════════════════ */
(function () {
  'use strict';

  /* ── globale helpers ──────────────────────────────────────────────────────── */
  var doc = document;
  var win = window;

  function reduceMotion() {
    try {
      return win.matchMedia && win.matchMedia('(prefers-reduced-motion:reduce)').matches;
    } catch (e) { return false; }
  }
  function designMode() {
    // Shopify theme editor: force everything visible / no autoplay surprises
    return !!(doc.documentElement && doc.documentElement.classList &&
              doc.documentElement.classList.contains('shopify-design-mode')) ||
           /(^|[?&])(design_mode|preview)/i.test(win.location ? win.location.search : '');
  }
  function toArr(nodeList) {
    return nodeList ? Array.prototype.slice.call(nodeList) : [];
  }
  function q(root, sel) {
    try { return (root || doc).querySelector(sel); } catch (e) { return null; }
  }
  function qa(root, sel) {
    try { return toArr((root || doc).querySelectorAll(sel)); } catch (e) { return []; }
  }
  // first matching selector from a list of candidate selectors (namespace tolerance)
  function qOne(root, sels) {
    for (var i = 0; i < sels.length; i++) {
      var el = q(root, sels[i]);
      if (el) return el;
    }
    return null;
  }
  function qAll(root, sels) {
    for (var i = 0; i < sels.length; i++) {
      var els = qa(root, sels[i]);
      if (els.length) return els;
    }
    return [];
  }
  function on(el, ev, fn, opts) {
    if (el && el.addEventListener) { try { el.addEventListener(ev, fn, opts || false); } catch (e) {} }
  }

  /* ── SITEWIDE FEEDBACK-LAAG ──────────────────────────────────────────────────
     Eén taal voor élke form: succes verbergt het form en toont het canon-succesblok
     (.mnt-formsuccess); een fout toont inline (.mnt-field-error) zodat je meteen
     corrigeert. Gebruikt door footer-waitlist, PDP-notify, waitlist en de discount-
     code in de cart. Password-fout is server-rendered (form.errors → .mnt-field-error)
     en deelt dezelfde vorm/tekst-toon zonder JS. */
  function fbSuccess(form, successEl) {
    if (form) { form.style.display = 'none'; form.setAttribute('aria-hidden', 'true'); }
    if (successEl) { successEl.hidden = false; successEl.classList.add('on'); }
  }
  function fbError(slot, msg) {
    if (!slot) return;
    slot.textContent = msg || '';
    slot.hidden = false;
    slot.className = 'mnt-field-error';   // wissel van rustende .mnt-field-note naar de foutvorm
  }
  function fbClearError(slot, restNote) {
    if (!slot) return;
    if (restNote != null) { slot.innerHTML = restNote; slot.className = 'mnt-field-note'; }
    else { slot.textContent = ''; slot.className = 'mnt-field-error'; }
  }


  /* ════════════════════════════════════════════════════════════════════════════
     1 · HERO — FADE-CAROUSEL  ([data-mnt-hero])
     Cross-fade .mnt-hero-slide children by toggling .on. Autoplay 7s, pause on
     hover, clickable pips [data-mnt-hero-pip], prev/next nav, wrap-around, swipe.
     Respects prefers-reduced-motion (no autoplay). Guards a single slide.
     ════════════════════════════════════════════════════════════════════════════ */
  function initHero(hero) {
    if (!hero || hero.__mntHero) return;
    hero.__mntHero = true;

    var slides = qAll(hero, ['.mnt-hero-slide', '[data-mnt-hero-slide]']);
    if (slides.length < 1) return;

    var pips = qAll(hero, ['[data-mnt-hero-pip]', '.mnt-hero-pips button']);
    var next = qOne(hero, ['[data-mnt-hero-next]', '.mnt-hero-nav.next']);
    var prev = qOne(hero, ['[data-mnt-hero-prev]', '.mnt-hero-nav.prev']);

    var i = 0, timer = null, paused = false;
    var DELAY = 7000;
    var reduced = reduceMotion();
    var single = slides.length < 2;

    function render() {
      for (var x = 0; x < slides.length; x++) {
        var isOn = x === i;
        if (slides[x].classList) slides[x].classList.toggle('on', isOn);
      }
      for (var y = 0; y < pips.length; y++) {
        var pOn = y === i;
        if (pips[y].classList) pips[y].classList.toggle('on', pOn);
        try { pips[y].setAttribute('aria-selected', pOn ? 'true' : 'false'); } catch (e) {}
      }
    }
    function go(n) {
      if (single) { i = 0; render(); return; }
      i = ((n % slides.length) + slides.length) % slides.length;
      render();
    }
    function fwd() { go(i + 1); }
    function back() { go(i - 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (reduced || single || paused || designMode()) return;
      timer = setInterval(fwd, DELAY);
    }

    for (var p = 0; p < pips.length; p++) {
      (function (idx, btn) {
        on(btn, 'click', function () {
          var attr = btn.getAttribute('data-mnt-hero-pip');
          go(attr != null && attr !== '' ? parseInt(attr, 10) : idx);
          start();
        });
      })(p, pips[p]);
    }
    on(next, 'click', function () { fwd(); start(); });
    on(prev, 'click', function () { back(); start(); });

    on(hero, 'mouseenter', function () { paused = true; stop(); });
    on(hero, 'mouseleave', function () { paused = false; start(); });
    on(doc, 'visibilitychange', function () { if (doc.hidden) stop(); else start(); });

    // touch-swipe
    var sx = 0, sy = 0, tracking = false;
    on(hero, 'touchstart', function (e) {
      if (!e.touches || !e.touches.length) return;
      sx = e.touches[0].clientX; sy = e.touches[0].clientY; tracking = true;
    }, { passive: true });
    on(hero, 'touchend', function (e) {
      if (!tracking || !e.changedTouches || !e.changedTouches.length) return;
      tracking = false;
      var dx = e.changedTouches[0].clientX - sx;
      var dy = e.changedTouches[0].clientY - sy;
      if (Math.abs(dx) > 44 && Math.abs(dx) > Math.abs(dy)) { if (dx < 0) fwd(); else back(); start(); }
    }, { passive: true });

    go(0);
    start();
  }


  /* ════════════════════════════════════════════════════════════════════════════
     2 · RAIL / PEEK CAROUSEL  ([data-mnt-rail])
     One-per-view carousel driven by translateX on the track. Mobile peek grids use
     native CSS scroll-snap (no JS) — this only drives an EXPLICIT rail: dots,
     prev/next, autoplay 5s, touch-swipe. Generic: supports the menta.css §1f
     contract ([data-rail-track]/.rail-dot) AND a [data-mnt-rail-*] namespace.
     ════════════════════════════════════════════════════════════════════════════ */
  function initRail(rail) {
    if (!rail || rail.__mntRail) return;
    rail.__mntRail = true;

    var track = qOne(rail, ['[data-mnt-rail-track]', '[data-rail-track]', '.rail-track']);
    if (!track) return;

    var slides = qAll(track, ['.rail-slide', '[data-mnt-rail-slide]']);
    if (!slides.length) slides = toArr(track.children);
    if (slides.length < 1) return;

    var dotsWrap = qOne(rail, ['[data-mnt-rail-dots]', '[data-rail-dots]', '.rail-dots']);
    var next = qOne(rail, ['[data-mnt-rail-next]', '[data-rail-next]', '.rail-nav.next']);
    var prev = qOne(rail, ['[data-mnt-rail-prev]', '[data-rail-prev]', '.rail-nav.prev']);

    // build dots if a dots container exists but is empty
    var dots = [];
    if (dotsWrap) {
      dots = qAll(dotsWrap, ['.rail-dot', 'button']);
      if (!dots.length && slides.length > 1) {
        for (var d = 0; d < slides.length; d++) {
          var b = doc.createElement('button');
          b.className = 'rail-dot';
          b.type = 'button';
          try { b.setAttribute('aria-label', 'Slide ' + (d + 1)); } catch (e) {}
          dotsWrap.appendChild(b);
          dots.push(b);
        }
      }
    }

    var i = 0, timer = null, paused = false, syncing = false;
    var DELAY = 5000;
    var reduced = reduceMotion();
    var single = slides.length < 2;

    // NATIVE SCROLL-SNAP: go(n) scrollt de track naar slide n. Geen transform meer.
    // De browser doet het slepen/swipen + het snappen; wij zetten alleen de scrollpositie
    // bij dots/pijlen/autoplay, en lezen de scrollpositie terug om de actieve dot te syncen.
    function slideLeft(n) {
      // robuust: gebruik de werkelijke offset van de slide t.o.v. de track
      return slides[n] ? slides[n].offsetLeft - track.offsetLeft : n * track.clientWidth;
    }
    function paintDots() {
      for (var x = 0; x < dots.length; x++) {
        if (dots[x].classList) dots[x].classList.toggle('on', x === i);
      }
    }
    function go(n) {
      if (single) { i = 0; paintDots(); return; }
      i = ((n % slides.length) + slides.length) % slides.length;
      syncing = true;
      try { track.scrollTo({ left: slideLeft(i), behavior: reduced ? 'auto' : 'smooth' }); }
      catch (e) { track.scrollLeft = slideLeft(i); }
      paintDots();
      // ontgrendel de scroll-listener kort na de programmatische scroll
      setTimeout(function () { syncing = false; }, 400);
    }
    function fwd() { go(i + 1); }
    function back() { go(i - 1); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() {
      stop();
      if (reduced || single || paused || designMode()) return;
      timer = setInterval(fwd, DELAY);
    }

    for (var p = 0; p < dots.length; p++) {
      (function (idx) { on(dots[idx], 'click', function () { go(idx); start(); }); })(p);
    }
    on(next, 'click', function () { fwd(); start(); });
    on(prev, 'click', function () { back(); start(); });

    on(rail, 'mouseenter', function () { paused = true; stop(); });
    on(rail, 'mouseleave', function () { paused = false; start(); });
    on(doc, 'visibilitychange', function () { if (doc.hidden) stop(); else start(); });

    // SCROLL-SYNC: als de gebruiker zelf swipet/scrollt, volg de actieve slide + dot.
    // Pauzeer autoplay tijdens hand-scroll, hervat kort erna. rAF-throttle.
    var st = null, ticking = false;
    on(track, 'scroll', function () {
      if (syncing) return;                 // negeer onze eigen programmatische scroll
      if (!ticking) {
        ticking = true;
        (win.requestAnimationFrame || function (cb) { setTimeout(cb, 16); })(function () {
          ticking = false;
          // welke slide staat het dichtst bij de linkerrand?
          var pos = track.scrollLeft, best = 0, bestD = Infinity;
          for (var x = 0; x < slides.length; x++) {
            var d = Math.abs((slides[x].offsetLeft - track.offsetLeft) - pos);
            if (d < bestD) { bestD = d; best = x; }
          }
          if (best !== i) { i = best; paintDots(); }
        });
      }
      // hand-scroll pauzeert autoplay even
      paused = true; stop();
      if (st) clearTimeout(st);
      st = setTimeout(function () { paused = false; start(); }, 1200);
    }, { passive: true });

    go(0);
    start();
  }


  /* ════════════════════════════════════════════════════════════════════════════
     3 · ACCORDEON — GESLOOPT. De class-based accordeon (.mnt-ac / .ac + initAccordion)
     was dode code (geen surface gebruikte 'm nog). Alle accordeons zijn nu native
     <details>/<summary> — die hebben géén JS nodig, de browser drijft ze aan. De
     sitewide-exclusieve variant (max 1 open) leeft in initAccordionRows. Een nieuwe
     surface heeft dus maar één accordeon-weg: <details>.
     ════════════════════════════════════════════════════════════════════════════ */


  /* ════════════════════════════════════════════════════════════════════════════
     4 · SCROLL-REVEAL  ([data-rv]  ·  .rv)
     Observe both conventions. On reveal: set data-rv="in" for [data-rv] elements,
     add .in for .rv elements — matching menta.css §1d ([data-rv="in"] / .rv.in).
     MANDATORY safety nets:
       · setTimeout ~1800ms force-reveals everything the observer may have missed
       · no-IntersectionObserver fallback reveals immediately
       · prefers-reduced-motion reveals immediately (motion suppressed in CSS too)
       · Shopify design mode force-reveals (editor jumps around; nothing must hide)
     A never-revealed element is worse than an un-animated one — so we over-reveal.
     ════════════════════════════════════════════════════════════════════════════ */
  function revealEl(el) {
    if (!el) return;
    try {
      if (el.hasAttribute && el.hasAttribute('data-rv')) el.setAttribute('data-rv', 'in');
    } catch (e) {}
    try { if (el.classList) el.classList.add('in'); } catch (e2) {}
  }
  function collectRevealables() {
    // union van de drie hooks [data-rv] · .rv · .reveal, de-duplicated. Alle drie zijn nu
    // dezelfde reveal-conventie (menta.css §1d); deze ene engine bedient ze allemaal, zodat
    // de aparte .reveal-observer in theme.liquid niet meer nodig is.
    var seen = [];
    function push(el) { if (seen.indexOf(el) === -1) seen.push(el); }
    qa(doc, '[data-rv]').forEach(push);
    qa(doc, '.rv').forEach(push);
    qa(doc, '.reveal').forEach(push);
    return seen;
  }
  function initReveal() {
    var items = collectRevealables();
    if (!items.length) return;

    function revealAll() { for (var i = 0; i < items.length; i++) revealEl(items[i]); }

    if (reduceMotion() || designMode() || !('IntersectionObserver' in win)) {
      revealAll();
      return;
    }

    var io;
    try {
      io = new IntersectionObserver(function (entries) {
        for (var i = 0; i < entries.length; i++) {
          if (entries[i].isIntersecting) {
            revealEl(entries[i].target);
            try { io.unobserve(entries[i].target); } catch (e) {}
          }
        }
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    } catch (e) {
      revealAll();
      return;
    }

    for (var k = 0; k < items.length; k++) {
      try { io.observe(items[k]); } catch (e2) { revealEl(items[k]); }
    }

    // MANDATORY vangnet — reveal everything after 1800ms no matter what
    win.setTimeout(revealAll, 1800);
  }


  /* ════════════════════════════════════════════════════════════════════════════
     SCROLL-PIPS — line-pips onder een native scroll-snap rij (de moment-strip
     .mnt-imgrow op mobiel). Geen translateX-engine: de rij scrollt native (CSS
     scroll-snap), deze functie bouwt alleen de pips, volgt de scroll-positie en
     markeert de actieve dia. Klik op een pip scrollt naar die dia. Alles guarded;
     de pips worden altijd gebouwd maar CSS toont ze alleen ≤640px (waar de rij een
     swipe is). Idempotent: draait niet twee keer op dezelfde rij.
     ════════════════════════════════════════════════════════════════════════════ */
  function initScrollPips(row) {
    if (!row || row.getAttribute('data-mnt-pips') === 'on') return;
    var cells = qa(row, '.mnt-imgcell');
    if (cells.length < 2) return;
    row.setAttribute('data-mnt-pips', 'on');

    // pip-rij net ná de scroll-rij invoegen
    var wrap = doc.createElement('div');
    wrap.className = 'mnt-imgrow-pips';
    var pips = [];
    for (var d = 0; d < cells.length; d++) {
      var b = doc.createElement('button');
      b.className = 'rail-dot';
      b.type = 'button';
      try { b.setAttribute('aria-label', 'Slide ' + (d + 1)); } catch (e) {}
      wrap.appendChild(b);
      pips.push(b);
    }
    if (row.parentNode) { row.parentNode.insertBefore(wrap, row.nextSibling); }

    var active = -1;
    function markActive(i) {
      if (i === active) return;
      active = i;
      for (var x = 0; x < pips.length; x++) {
        if (pips[x].classList) pips[x].classList.toggle('on', x === i);
      }
    }
    // welke cel zit het dichtst bij het midden van de viewport-rij?
    function nearest() {
      var mid = row.scrollLeft + row.clientWidth / 2;
      var best = 0, bestD = Infinity;
      for (var c = 0; c < cells.length; c++) {
        var cmid = cells[c].offsetLeft + cells[c].offsetWidth / 2;
        var dist = Math.abs(cmid - mid);
        if (dist < bestD) { bestD = dist; best = c; }
      }
      return best;
    }
    var raf = null;
    function onScroll() {
      if (raf) return;
      raf = (win.requestAnimationFrame || function (f) { return win.setTimeout(f, 60); })(function () {
        raf = null;
        markActive(nearest());
      });
    }
    on(row, 'scroll', onScroll, { passive: true });

    for (var p = 0; p < pips.length; p++) {
      (function (idx) {
        on(pips[idx], 'click', function () {
          var cell = cells[idx];
          if (!cell) return;
          var target = cell.offsetLeft - (row.clientWidth - cell.offsetWidth) / 2;
          try { row.scrollTo({ left: target, behavior: 'smooth' }); }
          catch (e) { row.scrollLeft = target; }
          markActive(idx);
        });
      })(p);
    }

    markActive(0);
  }

  /* PDP-GALERIJ PIPS — de .mbx-gallery is op mobiel een swipe-carousel (foto per keer,
     zoals de hero). Deze bouwt de line-pips eronder en houdt de actieve bij op scroll.
     Zelfde patroon als initScrollPips, maar voor .mbx-gallery > .g. Alleen actief als er
     meer dan één foto is; op desktop is de gallery een grid (pips blijven via CSS verborgen). */
  function initGalleryPips(row) {
    if (!row || row.getAttribute('data-mnt-gpips') === 'on') return;
    var cells = qa(row, '.g');
    if (cells.length < 2) return;
    row.setAttribute('data-mnt-gpips', 'on');
    var wrap = doc.createElement('div');
    wrap.className = 'mbx-gallery-pips';
    var pips = [];
    for (var d = 0; d < cells.length; d++) {
      var b = doc.createElement('button');
      b.className = 'rail-dot'; b.type = 'button';
      try { b.setAttribute('aria-label', 'Photo ' + (d + 1)); } catch (e) {}
      wrap.appendChild(b); pips.push(b);
    }
    if (row.parentNode) row.parentNode.insertBefore(wrap, row.nextSibling);
    var active = -1;
    function markActive(i){ if(i===active)return; active=i; for(var x=0;x<pips.length;x++){ if(pips[x].classList) pips[x].classList.toggle('on', x===i);} }
    function nearest(){ var mid=row.scrollLeft+row.clientWidth/2, best=0, bestD=Infinity; for(var c=0;c<cells.length;c++){ var cmid=cells[c].offsetLeft+cells[c].offsetWidth/2, dist=Math.abs(cmid-mid); if(dist<bestD){bestD=dist;best=c;} } return best; }
    var raf=null;
    on(row,'scroll',function(){ if(raf)return; raf=(win.requestAnimationFrame||function(f){return win.setTimeout(f,60);})(function(){ raf=null; markActive(nearest()); }); },{passive:true});
    for(var p=0;p<pips.length;p++){ (function(idx){ on(pips[idx],'click',function(){ var cell=cells[idx]; if(!cell)return; var target=cell.offsetLeft-(row.clientWidth-cell.offsetWidth)/2; try{row.scrollTo({left:target,behavior:'smooth'});}catch(e){row.scrollLeft=target;} markActive(idx); }); })(p); }
    markActive(0);
  }

  /* ════════════════════════════════════════════════════════════════════════════
     HEADER (§H) — glas-pill-shell + dropdown + mobiel drawer. Verbatim overgezet uit
     de live sections/header.liquid; class-selectors mhx→mnt-hdr, header-interne IDs
     mhxShell/Scrim/Dd → mntHdrShell/Scrim/Dd. Commerce-hook-IDs (mentaBurger, mentaDrawer,
     mentaDrawerClose, mentaDrawerOverlay) BYTE-IDENTIEK. appendChild-to-body + sticky-pop +
     hover/touch-dropdown + drawer-accordion + swipe-close behouden.
     ════════════════════════════════════════════════════════════════════════════ */
  function initHeader(){
    var root=document.querySelector('.mnt-hdr');if(!root)return;
    if(root.getAttribute('data-mnt-hdr-on')==='1')return; root.setAttribute('data-mnt-hdr-on','1');
      var shell=document.getElementById('mntHdrShell');
      var scrim=document.getElementById('mntHdrScrim');
      var dd=document.getElementById('mntHdrDd');
      var panel=dd.querySelector('.mnt-hdr-dd-panel');
      var contents=dd.querySelectorAll('.mnt-hdr-ddc');
      var items=root.querySelectorAll('.mnt-hdr-navitem');
      var overlay=document.getElementById('mentaDrawerOverlay');
      var drawer=document.getElementById('mentaDrawer');
      var burger=document.getElementById('mentaBurger');
      var dclose=document.getElementById('mentaDrawerClose');
      var current=null,closeTimer=null;

      /* ⚠️ GEEN scroll-lock hier. De body-lock hoort bij de cart-drawer. Twee locks
            over elkaar laten de tweede unlock naar de verkeerde scrollpositie terugspringen. */

      /* ── ontsnap de Shopify overflow-parent: shell + dd + scrim + drawer naar body ── */
      [shell,scrim,dd,overlay,drawer].forEach(function(el){
        if(el&&el.parentElement!==document.body){document.body.appendChild(el);}
      });

      function place(){
        var bar=shell&&shell.querySelector('.mnt-hdr-bar');if(!bar||!panel)return;
        var pad=parseFloat(getComputedStyle(shell).paddingTop)||0;
        panel.style.marginTop=(bar.offsetHeight+pad+8)+'px';
      }

      function show(key){
        clearTimeout(closeTimer);
        contents.forEach(function(c){c.hidden=c.getAttribute('data-for')!==key;});
        dd.classList.add('on');scrim.classList.add('on');
        root.classList.add('dd-open');if(shell)shell.classList.add('dd-open');
        items.forEach(function(it){it.classList.toggle('on',it.getAttribute('data-dd')===key);});
        current=key;place();
      }
      function hide(){
        dd.classList.remove('on');scrim.classList.remove('on');
        root.classList.remove('dd-open');if(shell)shell.classList.remove('dd-open');
        items.forEach(function(it){it.classList.remove('on');});current=null;
      }
      function scheduleHide(){clearTimeout(closeTimer);closeTimer=setTimeout(hide,220);}

      /* ── NAV ITEM — dropdown op hover, label is een echte link.
         Pointer-devices navigeren op klik (paneel stond al open op hover); touch opent
         op de eerste tik en volgt de link op de tweede. Media-query op klik-tijd lezen,
         zodat een hybride device dat wisselt blijft kloppen. Focus opent 'm ook. ── */
      function canHover(){
        return window.matchMedia('(hover:hover) and (pointer:fine)').matches;
      }
      items.forEach(function(it){
        var key=it.getAttribute('data-dd');
        it.addEventListener('mouseenter',function(){show(key);});
        it.addEventListener('mouseleave',scheduleHide);
        it.addEventListener('focusin',function(){show(key);});
        it.addEventListener('focusout',function(e){
          if(!it.contains(e.relatedTarget))scheduleHide();
        });
        var trig=it.querySelector('.mnt-hdr-trig');
        if(trig)trig.addEventListener('click',function(e){
          if(canHover())return;
          if(current!==key){e.preventDefault();show(key);}
        });
      });
      panel.addEventListener('mouseenter',function(){clearTimeout(closeTimer);});
      panel.addEventListener('mouseleave',scheduleHide);
      scrim.addEventListener('click',hide);

      /* ── pop bij scroll ── (shell is nu meteen position:fixed via CSS; geen is-fixed-toggle meer) */
      function onScroll(){if(window.scrollY>20){shell.classList.add('pop');}else{shell.classList.remove('pop');}place();}
      window.addEventListener('scroll',onScroll,{passive:true});
      window.addEventListener('resize',place);
      window.addEventListener('load',function(){place();onScroll();});
      place();onScroll();

      /* ── drawer ── */
      function openD(){if(overlay)overlay.classList.add('open');if(drawer)drawer.classList.add('open');if(burger)burger.setAttribute('aria-expanded','true');document.body.style.overflow='hidden';}
      function closeD(){if(overlay)overlay.classList.remove('open');if(drawer)drawer.classList.remove('open');if(burger)burger.setAttribute('aria-expanded','false');document.body.style.overflow='';}
      if(burger)burger.addEventListener('click',openD);
      if(dclose)dclose.addEventListener('click',closeD);
      if(overlay)overlay.addEventListener('click',closeD);
      document.addEventListener('keydown',function(e){if(e.key==='Escape'){hide();closeD();}});

      (function(){
        if(!drawer)return;
        var accs=drawer.querySelectorAll('details.mnt-hdr-libdd');
        for(var a=0;a<accs.length;a++){
          (function(el){
            el.addEventListener('toggle',function(){
              if(!el.open)return;
              for(var b=0;b<accs.length;b++){ if(accs[b]!==el) accs[b].removeAttribute('open'); }
            });
          })(accs[a]);
        }
        var links=drawer.querySelectorAll('a[href]');
        for(var l=0;l<links.length;l++) links[l].addEventListener('click',closeD);
        var x0=null;
        drawer.addEventListener('touchstart',function(e){x0=e.touches[0].clientX;},{passive:true});
        drawer.addEventListener('touchend',function(e){
          if(x0===null)return;
          var dx=e.changedTouches[0].clientX-x0;
          if(dx<-70) closeD();
          x0=null;
        },{passive:true});
      })();
  }

  /* ════════════════════════════════════════════════════════════════════════════
     FOOTER (§FTR). Vier mechanismes: Klaviyo-newsletter-submit · cookie-preferences ·
     regio/valuta-selector · back-to-top. Hooks: #mftForm/#mftEmail/#mftSubmit/#mftNote/#mftSuccess ·
     #mfootCookies (window.MENTA_PRIVACY) · valuta: TRIGGER #mcurBtn opent de sheet #mcurSheet via de
     sitewide sheet-motor (data-sheet-open), keuze via radio's [name=mcur], toepassen via #mcurApply
     → #mcurForm/#mcurCode · #mbt-btn. Guarded (return als de knopen niet bestaan), idempotent via
     data-mnt-ftr-on. De back-to-top verhuist naar <body>; het regio-paneel is een §42 .mnt-sheet
     (<dialog>, top-layer) en hoeft dus NIET meer gereparenteerd te worden.
     ════════════════════════════════════════════════════════════════════════════ */
  function initFooter(){
    var root=document.querySelector('.mfoot');
    if(!root)return;
    if(root.getAttribute('data-mnt-ftr-on')==='1')return; root.setAttribute('data-mnt-ftr-on','1');

    /* ── nav-kolommen: op DESKTOP altijd open (CSS kan een gesloten <details> niet betrouwbaar
       forceren — de UA verbergt de content-slot), op MOBIEL accordion (standaard dicht).
       Zet 'open' via JS op ≥821px, ruim 'm weer op onder 821px. Herrun op resize. ── */
    (function(){
      var accs=root.querySelectorAll('details.mfoot-navgrp');
      if(!accs.length)return;
      function sync(){
        var desk = window.matchMedia('(min-width:821px)').matches;
        for(var i=0;i<accs.length;i++){
          if(desk){ accs[i].setAttribute('open',''); }
          else if(!accs[i].hasAttribute('data-user')){ accs[i].removeAttribute('open'); }
        }
      }
      /* onthoud of de gebruiker zélf op mobiel iets opende, zodat een resize dat niet dichtklapt */
      for(var i=0;i<accs.length;i++){
        (function(el){ el.addEventListener('toggle',function(){
          if(!window.matchMedia('(min-width:821px)').matches){ el.setAttribute('data-user','1'); }
        }); })(accs[i]);
      }
      sync();
      var mq=window.matchMedia('(min-width:821px)');
      (mq.addEventListener?mq.addEventListener.bind(mq,'change'):mq.addListener.bind(mq))(sync);
    })();

    /* ── Klaviyo newsletter submit (payload 1:1) — sitewide feedback-laag ── */
    (function(){
      var form=document.getElementById('mftForm');
      var input=document.getElementById('mftEmail');
      var btn=document.getElementById('mftSubmit');
      var note=document.getElementById('mftNote');
      var success=document.getElementById('mftSuccess');
      if(!form)return;
      var restNote=note?note.innerHTML:null;   // rustende subregel, om te herstellen
      if(input) on(input,'input',function(){ fbClearError(note,restNote); });
      form.addEventListener('submit',function(e){
        e.preventDefault();
        var email=input.value.trim();
        if(!email||!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)){ fbError(note,'Enter a valid email address.'); return; }
        btn.disabled=true;
        var payload={data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{email:email,properties:{source:'footer_newsletter',signup_location:'footer'}}}}},relationships:{list:{data:{type:'list',id:'Tptrie'}}}}};
        fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XCUvdG',{
          method:'POST',
          headers:{'Content-Type':'application/json','revision':'2023-12-15','Accept':'application/json'},
          body:JSON.stringify(payload)
        }).then(function(r){
          if(r.ok||r.status===202){ if(note)note.hidden=true; fbSuccess(form,success); }
          else{ btn.disabled=false; fbError(note,'Something went wrong. Try again.'); }
        }).catch(function(){ btn.disabled=false; fbError(note,'Something went wrong. Try again.'); });
      });
    })();

    /* ── cookie preferences: alleen tonen als de consent-snippet geladen is ── */
    (function(){
      var b=document.getElementById('mfootCookies');
      if(!b)return;
      function ready(){ return window.MENTA_PRIVACY && window.MENTA_PRIVACY.open; }
      function arm(){ if(ready()){ b.hidden=false; return true; } return false; }
      if(!arm()){
        var n=0,t=setInterval(function(){ if(arm()||++n>40) clearInterval(t); },250);
      }
      b.addEventListener('click',function(){ if(ready()) window.MENTA_PRIVACY.open(); });
    })();

    /* ── regio & valuta ── OPENEN/SLUITEN doet de sitewide sheet-motor (initSheet via
       data-sheet-open="mcurSheet" + initGrabDismiss). Hier alléén: (a) de form+sheet naar <body>
       verhuizen — anders vangt de footer-reset (.mfoot *{padding:0;margin:0}) de sheet-inhoud en
       vervalt alle padding; buiten .mfoot erft de sheet netjes de motor; (b) de keuze-logica: radio
       kiezen → Apply enabled zodra je iets ánders kiest dan de huidige regio; Apply → zet #mcurCode
       uit de gekozen radio en submit de 'localization'-form (Shopify reload met de nieuwe markt). ── */
    (function(){
      var form=document.getElementById('mcurForm');
      var code=document.getElementById('mcurCode');
      var apply=document.getElementById('mcurApply');
      var sheet=document.getElementById('mcurSheet');
      if(!form||!code||!apply||!sheet)return;

      // uit .mfoot halen (de hele form, zodat de dialog én de submit intact blijven): de
      // footer-chrome reset (.mfoot *{padding:0}) mag de sheet niet raken. Naar <body>.
      if(form.parentElement!==document.body)document.body.appendChild(form);

      var radios=Array.prototype.slice.call(sheet.querySelectorAll('input[name="mcur"]'));
      if(!radios.length)return;

      // de bij het laden gekozen regio = de huidige markt; Apply heeft pas zin bij een ándere keuze.
      var initial='';
      radios.forEach(function(r){ if(r.checked)initial=r.value; });

      function selected(){
        for(var i=0;i<radios.length;i++){ if(radios[i].checked)return radios[i].value; }
        return initial;
      }
      function sync(){ apply.disabled=(selected()===initial); }
      sync();

      radios.forEach(function(r){ r.addEventListener('change',sync); });

      // Apply = submit; zet de country_code uit de gekozen radio. Geen verschil → niets doen.
      form.addEventListener('submit',function(e){
        var v=selected();
        if(v===initial){ e.preventDefault(); return; }
        code.value=v;
        // native submit gaat door (Shopify localization → reload met nieuwe markt)
      });
    })();

    /* ── back-to-top: toon na ~90vh scroll via IntersectionObserver (geen scroll-listener) ──
       Een onzichtbare sentinel op ~90vh vanaf de top: zodra die de viewport uit scrollt, tonen we
       de knop. IO vuurt alleen bij het passeren van de grens, niet elke frame — robuuster dan een
       scroll-listener. De klik scrollt native smooth naar boven. Fallback: als IO ontbreekt, toon
       de knop gewoon (nette faalstand). */
    (function(){
      var btn=document.getElementById('mbt-btn');
      if(!btn)return;
      if(btn.parentElement!==document.body)document.body.appendChild(btn);
      btn.addEventListener('click',function(){window.scrollTo({top:0,behavior:'smooth'});});
      if(!('IntersectionObserver' in window)){ btn.classList.add('mbt-show'); return; }
      // sentinel: 1px hoog, absoluut op 90vh vanaf de top van het document
      var mark=document.createElement('div');
      mark.setAttribute('aria-hidden','true');
      mark.style.cssText='position:absolute;top:90vh;left:0;width:1px;height:1px;pointer-events:none;';
      document.body.appendChild(mark);
      new IntersectionObserver(function(entries){
        btn.classList.toggle('mbt-show', !entries[0].isIntersecting);
      }).observe(mark);
    })();
  }

  /* ════════════════════════════════════════════════════════════════════════════
     SHEET — bottom-sheet drawer (.mnt-sheet). Een trigger [data-sheet-open="<id>"]
     opent de .mnt-sheet met dat id; scrim/[data-sheet-close]/Escape sluit. Delegated
     op document, één keer gebonden (guard) — werkt voor elke sheet op de pagina.
     ════════════════════════════════════════════════════════════════════════════ */
  function initSheet() {
    if (window.__mntSheetHooked) return;
    window.__mntSheetHooked = true;

    /* ── NATIVE <dialog> — de browser doet het werk, wij leveren alleen de CSS-huid ──────────
       De sheet IS een <dialog>. showModal() geeft gratis: de ::backdrop (dim/blur, altijd volle
       viewport), Escape-sluit, focus-trap, scroll-lock, top-layer boven álles. Geen losse scrim,
       geen reparent, geen handmatige lock — dat bouwden we eerst zelf na en dát brak. Wat blijft:
       de trigger vertaalt naar showModal(), het kruisje/close naar close(), en klik-buiten =
       klik op het dialog-element zelf (dan zit de klik op de backdrop, buiten de content). */
    function open(id) {
      var d = doc.getElementById(id);
      if (!d || typeof d.showModal !== 'function') return;
      if (d.open) return;
      try { d.showModal(); } catch (e) {}
    }

    // trigger + kruisje: gedelegeerd op document (guarded, werkt voor élke sheet sitewide).
    on(doc, 'click', function (e) {
      var t = e.target;
      if (!t || !t.closest) return;
      var trig = t.closest('[data-sheet-open]');
      if (trig) { e.preventDefault(); open(trig.getAttribute('data-sheet-open')); return; }
      var closer = t.closest('[data-sheet-close]');
      if (closer) {
        e.preventDefault();
        var dc = closer.closest('.mnt-sheet');
        if (dc && dc.open) dc.close();
        return;
      }
    });
    // KLIK-BUITEN (op de backdrop) — robuust via de bounding-rect: het dialog vult z'n eigen
    // content, dus we kunnen niet op "e.target === dialog" leunen. In plaats daarvan: staat de klik
    // buiten het dialog-rechthoek, dan zat 'ie op de backdrop → sluiten. Werkt altijd.
    on(doc, 'click', function (e) {
      var d = doc.querySelector('.mnt-sheet[open]');
      if (!d) return;
      // negeer als de klik binnen het dialog viel, of op een trigger (die opent net)
      if (e.target.closest && e.target.closest('[data-sheet-open]')) return;
      var r = d.getBoundingClientRect();
      var inside = e.clientX >= r.left && e.clientX <= r.right && e.clientY >= r.top && e.clientY <= r.bottom;
      if (!inside) d.close();
    });
    // Escape sluit al native; niets extra nodig.
  }

  /* ════════════════════════════════════════════════════════════════════════════
     GRAB-DISMISS — het grip-streepje bovenaan een bottom-sheet werkt nu ECHT: sleep
     de grip omlaag en de sheet volgt je vinger; laat je los voorbij de drempel → hij
     sluit, anders veert 'ie terug. SITEWIDE, één engine, één keer gebonden (guard).

     GEEN dubbele sluit-logica: de engine sluit elke sheet via z'n EIGEN bestaande
     sluit-methode (config hieronder) — de filter-sheet via z'n close-knop, de active-
     drawer via native dialog.close(). Nieuwe bottom-sheets voeg je toe door één regel
     in SHEETS te zetten (paneel-selector · grip-selector · open-check · close-fn) —
     dat is het hele contract, geen markup-wijziging nodig.

     Werkt met touch én muis (pointer events, fallback touch). Alleen verticaal omlaag;
     omhoog slepen doet niets (de sheet zit al aan de onderkant). Respecteert reduced-
     motion (dan sluit een voldoende sleep direct, zonder mee-animeren).
     ════════════════════════════════════════════════════════════════════════════ */
  function initGrabDismiss() {
    if (win.__mntGrabHooked) return;
    win.__mntGrabHooked = true;

    /* De sitewide sheet-registratie. Elk item:
         panel  — selector van het bewegende paneel (de sheet)
         grip   — selector van de grip-zone binnen het paneel (waar je 'm vastpakt)
         isOpen — is de sheet nu open?
         close  — sluit de sheet via z'n eigen methode (geen nieuwe sluit-logica)
         x      — vaste horizontale transform-offset van de sheet in open staat (default ''). De
                  §42 .mnt-sheet staat op mobiel gecentreerd via translate(-50%,0); zonder deze
                  offset zou een translateY() tijdens het slepen die centrering wegvagen en de sheet
                  50% naar rechts laten springen. De collectie-sheet heeft geen X-offset ('').
                  Zo volgt élke geregistreerde sheet de vinger zónder zijwaarts te verschuiven. */
    var SHEETS = [
      { // COLLECTIE — filter & sort bottom-sheet
        panel: '.mnt-col-side',
        grip: '.mnt-col-sheet-head',
        x: '',
        isOpen: function (p) { return p.classList.contains('on'); },
        close: function (p) {
          var btn = p.querySelector('[data-col-sheet-close]');
          if (btn) btn.click(); else p.classList.remove('on');
        }
      },
      { // ACTIVE-DRAWER / REGIO-SHEET / elke §42 .mnt-sheet — native <dialog> bottom-sheet (mobiel),
        // gecentreerd (translateX(-50%)) → die offset moet bij het slepen behouden blijven.
        panel: '.mnt-sheet',
        grip: '.mnt-sheet-grab',
        x: '-50%',
        isOpen: function (p) { return p.open; },
        close: function (p) { try { p.close(); } catch (e) {} }
      }
    ];

    var CLOSE_RATIO = 0.28;   // voorbij 28% van de paneelhoogte omlaag → sluiten
    var CLOSE_PX = 90;        // of minstens 90px absoluut (korte sheets)
    var FLICK_V = 0.6;        // of een snelle flick omlaag (px/ms)

    function grabZoneFor(target) {
      // vind welke geregistreerde sheet + grip deze pointerdown betreft
      if (!target || !target.closest) return null;
      // een tap op een knop/link/veld binnen de grip is GEEN sleep (X-knop, titel-actie, …)
      if (target.closest('button, a, input, select, textarea, [role="button"]')) return null;
      for (var i = 0; i < SHEETS.length; i++) {
        var cfg = SHEETS[i];
        var grip = target.closest(cfg.grip);
        if (!grip) continue;
        var panel = grip.closest(cfg.panel);
        if (!panel || !cfg.isOpen(panel)) continue;
        return { cfg: cfg, panel: panel, grip: grip };
      }
      return null;
    }

    var active = null;   // { cfg, panel, startY, startT, h, prevTransition }

    function onDown(e) {
      if (active) return;
      // alleen primaire pointer / enkele touch
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      var pt = e.touches ? e.touches[0] : e;
      var zone = grabZoneFor(e.target);
      if (!zone) return;
      active = {
        cfg: zone.cfg, panel: zone.panel,
        x: zone.cfg.x || '',                     // horizontale offset behouden tijdens de sleep
        startY: pt.clientY, startT: Date.now(),
        lastY: pt.clientY, lastT: Date.now(),
        h: zone.panel.getBoundingClientRect().height || win.innerHeight,
        prevTransition: zone.panel.style.transition
      };
      // paneel volgt de vinger 1:1 → transition uit tijdens het slepen
      if (!reduceMotion()) active.panel.style.transition = 'none';
      // voorkom dat de pagina meescrolt terwijl je de grip sleept
      if (e.cancelable) e.preventDefault();
    }

    function onMove(e) {
      if (!active) return;
      var pt = e.touches ? e.touches[0] : e;
      var dy = pt.clientY - active.startY;
      active.lastY = pt.clientY; active.lastT = Date.now();
      if (dy < 0) dy = 0;                       // alleen omlaag
      // translate(<x>, dy): de X-offset (bv. -50% voor de gecentreerde .mnt-sheet) blijft staan,
      // zodat de sheet recht omlaag volgt zonder zijwaarts te springen.
      if (!reduceMotion()) active.panel.style.transform = 'translate(' + (active.x || '0') + ',' + dy + 'px)';
      if (e.cancelable) e.preventDefault();
    }

    function settle(dismiss) {
      if (!active) return;
      var a = active; active = null;
      // transition herstellen zodat terugveren/sluiten netjes animeert
      a.panel.style.transition = a.prevTransition || '';
      a.panel.style.transform = '';            // terug naar de CSS-staat (dicht óf open)
      if (dismiss) a.cfg.close(a.panel);
    }

    function onUp(e) {
      if (!active) return;
      var pt = (e.changedTouches && e.changedTouches[0]) || e;
      var dy = Math.max(0, pt.clientY - active.startY);
      var dt = Math.max(1, Date.now() - active.lastT + 1);
      var v = (pt.clientY - active.lastY) / dt;     // px/ms, laatste beweging
      var far = dy > active.h * CLOSE_RATIO || dy > CLOSE_PX;
      var flick = v > FLICK_V && dy > 24;
      settle(far || flick);
    }

    function onCancel() { settle(false); }

    // Pointer events dekken muis + touch in één; touch-fallback voor oudere engines.
    var hasPointer = 'PointerEvent' in win;
    if (hasPointer) {
      on(doc, 'pointerdown', onDown, { passive: false });
      on(doc, 'pointermove', onMove, { passive: false });
      on(doc, 'pointerup', onUp);
      on(doc, 'pointercancel', onCancel);
    } else {
      on(doc, 'touchstart', onDown, { passive: false });
      on(doc, 'touchmove', onMove, { passive: false });
      on(doc, 'touchend', onUp);
      on(doc, 'touchcancel', onCancel);
    }
  }

  /* ════════════════════════════════════════════════════════════════════════════
     ACCORDION-ROWS — uitklapbare genummerde rijen (.mnt-rows.ac details). SITEWIDE
     EXCLUSIEF: er staat maximaal één rij open op de hele pagina; opent er één, dan
     sluiten alle andere. Eén delegated 'toggle'-listener, één keer gebonden (guard).
     ════════════════════════════════════════════════════════════════════════════ */
  function initAccordionRows() {
    if (window.__mntAcRowsHooked) return;
    window.__mntAcRowsHooked = true;
    // Groepen waarbinnen maximaal ÉÉN <details> open mag staan (native accordion-gedrag).
    // Zowel de sitewide genummerde rijen (§FAQ) als de buybox-disclosure-stack (PDP).
    var EXCL = '.mnt-rows.ac, .mbx-disc-stack';
    // 'toggle' bubbelt niet, dus capture-fase op document.
    doc.addEventListener('toggle', function (e) {
      var d = e.target;
      if (!d || d.nodeName !== 'DETAILS' || !d.open) return;
      var grp = d.closest ? d.closest(EXCL) : null;
      if (!grp) return;
      // sluit alleen de andere open <details> BINNEN dezelfde groep
      qa(grp, 'details[open]').forEach(function (other) {
        if (other !== d) other.open = false;
      });
    }, true);
  }

  /* ════════════════════════════════════════════════════════════════════════════
     BOOT — scan the DOM once, wire every mechanism. Guarded so one failure can
     never stop the others. Re-scannable for Shopify section reloads in the editor.
     ════════════════════════════════════════════════════════════════════════════ */
  /* ── BUYBOX (§BX) — purchase-toggle (sub/otp) + Klaviyo notify. Add-to-cart zelf
     loopt via de MENTACart form-intercept; deze zet alleen selling_plan + label.
     Guarded + idempotent, section-reload-safe. ── */
  function initBuybox(scope) {
    scope = scope || doc;
    qa(scope, '[data-mbx-opts]').forEach(function (box) {
      if (box.__mbxWired) return; box.__mbxWired = true;
      var buy    = box.closest ? box.closest('.mbx-buy') : box.parentNode;
      var form   = doc.getElementById('mbx-form');
      var plan   = form ? form.querySelector('[data-mbx-plan]') : null;
      var label  = form ? form.querySelector('[data-mbx-label]') : null;
      var cells  = qa(box, '[data-mbx-opt]');
      var freqWrap  = buy ? buy.querySelector('[data-mbx-freqs]') : null;
      var freqCells = freqWrap ? qa(freqWrap, '[data-mbx-freq]') : [];
      function pickedFreqPlan() {
        var on = null;
        freqCells.forEach(function (c) { if (c.getAttribute('aria-checked') === 'true') on = c; });
        on = on || freqCells[0];
        return on ? (on.getAttribute('data-plan-id') || '') : (box.getAttribute('data-plan-id') || '');
      }
      function selectFreq(cell) {
        freqCells.forEach(function (c) { c.setAttribute('aria-checked', c === cell ? 'true' : 'false'); });
        if (plan) plan.value = cell.getAttribute('data-plan-id') || '';
      }
      function select(mode) {
        cells.forEach(function (c) {
          c.setAttribute('aria-checked', c.getAttribute('data-mbx-opt') === mode ? 'true' : 'false');
        });
        if (mode === 'sub') {
          if (freqWrap) freqWrap.hidden = false;
          if (plan)  plan.value = pickedFreqPlan();
          if (label) label.textContent = 'Subscribe & save';
        } else {
          if (freqWrap) freqWrap.hidden = true;
          if (plan)  plan.value = '';
          if (label) label.textContent = 'Add to cart';
        }
      }
      cells.forEach(function (c) {
        on(c, 'click', function () { select(c.getAttribute('data-mbx-opt')); });
        on(c, 'keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); select(c.getAttribute('data-mbx-opt')); }
        });
      });
      freqCells.forEach(function (c, idx) {
        if (c.getAttribute('aria-checked') == null) c.setAttribute('aria-checked', idx === 0 ? 'true' : 'false');
        on(c, 'click', function () { selectFreq(c); });
        on(c, 'keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); selectFreq(c); }
        });
      });
      select('sub');
    });
    qa(scope, '[data-mbx-notify]').forEach(function (nf) {
      if (nf.__mbxNotify) return; nf.__mbxNotify = true;
      var msg    = nf.querySelector('[data-mbx-notify-msg]');     // rustende subregel + foutslot
      var input  = nf.querySelector('input[type=email]');
      var listId = nf.getAttribute('data-klaviyo-list') || '';
      // succesblok = sibling naast het form (zelfde parent-kolom)
      var success = nf.parentNode ? nf.parentNode.querySelector('[data-mbx-notify-success]') : null;
      var restNote = msg ? msg.innerHTML : null;
      var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (input) on(input, 'input', function () { fbClearError(msg, restNote); });
      function done() { fbSuccess(nf, success); }
      on(nf, 'submit', function (e) {
        e.preventDefault();
        var email = input ? input.value.trim() : '';
        if (!email || !EMAIL.test(email)) { fbError(msg, 'Enter a valid email address.'); return; }
        if (!listId) { done(); return; }
        var body = new URLSearchParams();
        body.append('g', listId); body.append('email', email); body.append('$fields', 'email');
        fetch('https://manage.kmail-lists.com/ajax/subscriptions/subscribe', {
          method: 'POST',
          headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Cache-Control': 'no-cache' },
          body: body.toString()
        }).then(function (r) { return r.json(); })
          .then(function () { done(); })
          .catch(function () { fbError(msg, 'Something went wrong. Try again.'); });
      });
    });
  }

  /* ── STICKY ATC (PDP): toon de vaste koopbalk zodra de hero-buybox uit beeld scrollt.
     Zelfde IO-patroon als back-to-top — observeer .mbx-hero; verlaat 'ie de viewport (naar boven),
     dan .on aan; komt 'ie terug, .on uit. [hidden]/aria weggehaald bij eerste tonen. Geen sticky
     op designMode (Shopify editor) om overlap te voorkomen. */
  function initStickyATC(scope) {
    scope = scope || doc;
    var bar = qa(scope, '[data-mbx-sticky]')[0];
    var hero = qa(scope, '.mbx-hero')[0];
    if (!bar || !hero || bar.__mbxStickyWired) return;
    bar.__mbxStickyWired = true;

    /* segmented sub|otp toggle in de balk — update prijs, hidden selling_plan en knop-label */
    var seg = qa(bar, '[data-mbx-sopts]')[0];
    if (seg) {
      var sform = doc.getElementById('mbx-sticky-form');
      var splan = sform ? sform.querySelector('[data-mbx-splan]') : null;
      var slabel = bar.querySelector('[data-mbx-slabel]');
      var sprice = bar.querySelector('[data-mbx-sprice]');
      var planId = seg.getAttribute('data-plan-id') || '';
      var subPr = seg.getAttribute('data-sub-pr') || '';
      var otpPr = seg.getAttribute('data-otp-pr') || '';
      var cells = qa(bar, '[data-mbx-sopt]');
      function sselect(mode) {
        cells.forEach(function (c) { c.setAttribute('aria-checked', c.getAttribute('data-mbx-sopt') === mode ? 'true' : 'false'); });
        if (mode === 'sub') {
          if (splan) splan.value = planId;
          if (slabel) slabel.textContent = 'Subscribe & save';
          if (sprice) sprice.innerHTML = subPr + ' <span class="was">' + otpPr + '</span>';
        } else {
          if (splan) splan.value = '';
          if (slabel) slabel.textContent = 'Add to cart';
          if (sprice) sprice.textContent = otpPr;
        }
      }
      cells.forEach(function (c) { on(c, 'click', function () { sselect(c.getAttribute('data-mbx-sopt')); }); });
      sselect('sub');
    }

    if (designMode() || !('IntersectionObserver' in win)) return;
    function reveal(show) {
      if (show) { bar.hidden = false; bar.setAttribute('aria-hidden', 'false'); bar.classList.add('on'); }
      else { bar.classList.remove('on'); bar.setAttribute('aria-hidden', 'true'); }
    }
    new IntersectionObserver(function (entries) {
      var e = entries[0];
      // toon alleen als de hero BOVEN de viewport is (omhoog gescrold), niet wanneer 'ie eronder zit
      reveal(!e.isIntersecting && e.boundingClientRect.top < 0);
    }, { threshold: 0 }).observe(hero);
  }

  /* ── WAITLIST-PAGINA ([data-mnt-waitlist]) — Klaviyo-signup + reveal-unlock ────
     Was inline in de surface; nu hier zodat 'ie de sitewide feedback-laag deelt
     (fbSuccess/fbError, dezelfde teksten als footer/PDP). Uniek aan de waitlist is
     alleen de reveal-unlock: bij succes .is-done op de root → CSS toont het canon-
     succesblok + opent de reveal-scroll. 0 JS in de surface. */
  function initWaitlist(root) {
    if (!root || root.__mntWl) return; root.__mntWl = true;
    var form = q(root, '#mwlForm');
    var input = q(root, '#mwlEmail');
    var btn = q(root, '#mwlSubmit');
    var note = q(root, '#mwlNote');
    var reveal = q(root, '#mwlReveal');
    var scrollBtn = q(root, '#mwlScroll');
    var revealTop = q(root, '#mwlRevealTop');
    if (!form) return;
    var restNote = note ? note.innerHTML : null;
    var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    function unlock() { root.classList.add('is-done'); if (reveal) reveal.hidden = false; }
    if (input) on(input, 'input', function () { fbClearError(note, restNote); });
    on(form, 'submit', function (e) {
      e.preventDefault();
      var email = (input && input.value || '').trim();
      if (!email || !EMAIL.test(email)) { fbError(note, 'Enter a valid email address.'); return; }
      if (btn) btn.disabled = true;
      var payload = {data:{type:'subscription',attributes:{profile:{data:{type:'profile',attributes:{email:email,properties:{source:'waitlist_page',signup_location:'waitlist_page'}}}}},relationships:{list:{data:{type:'list',id:'Tptrie'}}}}};
      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=XCUvdG', {
        method:'POST',
        headers:{'Content-Type':'application/json','revision':'2023-12-15','Accept':'application/json'},
        body:JSON.stringify(payload)
      }).then(function (r) {
        if (r.ok || r.status === 202) { unlock(); }
        else { if (btn) btn.disabled = false; fbError(note, 'Something went wrong. Try again.'); }
      }).catch(function () { if (btn) btn.disabled = false; fbError(note, 'Something went wrong. Try again.'); });
    });
    if (scrollBtn) on(scrollBtn, 'click', function () {
      if (revealTop) revealTop.scrollIntoView({ behavior:'smooth', block:'start' });
    });
  }

  /* ════════════════════════════════════════════════════════════════════════════
     KOP-ACCENT — sitewide auto-highlight (§head-accent). De homepage-koppen dragen een
     handmatig accent (<span class="thin r"> = grijs+rood op een deel van de kop). Op de
     content-pages (Evidence, Our Story, PDP) viel dat accent uit de OPGESLAGEN editable
     kop-waardes: de theme-editor strip HTML uit z'n text-velden, dus wat overblijft is
     kale tekst. Deze engine herstelt het accent LIVE, ongeacht de editor:

       · Een kop die AL een .thin of .r span heeft → met rust (handmatig accent blijft exact).
       · Een kop met complexe structuur (<b>, <br>, geneste elementen, richtext-<p>) → met rust
         (te riskant om te splitsen; die dragen hun accent al of horen kaal).
       · Een KALE platte-tekst-kop → highlight automatisch het laatste deel (na het laatste
         zins-scharnier: '. ', ' — ' em-dash, ' : ') met <span class="thin r">. Geen scharnier
         → de laatste ~40% van de woorden. Matcht het homepage-patroon.

     Idempotent (data-attribuut-gemarkeerd), guarded, draait ook na een theme-editor-re-render.
     Raakt alleen .display/.h1/.h2/.h3 — die leven uitsluitend in content, nooit in de chrome
     (header/footer/cart dragen hun eigen mnt-hdr / mfoot / mnt-cart prefixen). ════════════ */
  function initHeadAccent(scope) {
    scope = scope || doc;
    var heads = qa(scope, '.display, .h1, .h2, .h3');
    heads.forEach(function (h) {
      if (h.getAttribute('data-hacc') === '1') return;       // al verwerkt
      // AL een accent (.thin/.r) ergens in de kop → handmatig gezet, niet aanraken.
      if (h.querySelector('.thin, .r')) { h.setAttribute('data-hacc', '1'); return; }
      // Complexe inhoud (geneste elementen, <b>, <br>, richtext-<p>) → overslaan.
      if (h.children && h.children.length > 0) { h.setAttribute('data-hacc', '1'); return; }
      var txt = (h.textContent || '').trim();
      if (txt.length < 8) { h.setAttribute('data-hacc', '1'); return; }   // te kort om te splitsen

      // ── bepaal het accent-deel = het laatste zins-scharnier + wat erna komt ──
      // scharnieren, in prioriteit: em-dash ' — ', punt '. ', dubbele punt ': '
      var splitAt = -1, sepLen = 0;
      var seps = [' — ', '. ', ': '];   // em-dash · punt+spatie · dubbele punt+spatie
      seps.forEach(function (sep) {
        var idx = txt.lastIndexOf(sep);
        // niet te dicht op het einde (dan blijft er niks te highlighten), niet op positie 0
        if (idx > 3 && idx + sep.length < txt.length - 2 && idx > splitAt) { splitAt = idx; sepLen = sep.length; }
      });

      var head, tail;
      if (splitAt > -1) {
        // alles t/m het scharnier blijft gewoon; het deel ERNA wordt het accent.
        head = txt.slice(0, splitAt + sepLen);
        tail = txt.slice(splitAt + sepLen);
      } else {
        // geen scharnier → laatste ~40% van de woorden accenten.
        var words = txt.split(/\s+/);
        if (words.length < 3) { h.setAttribute('data-hacc', '1'); return; }  // te kort
        var cut = Math.max(1, Math.round(words.length * 0.4));
        head = words.slice(0, words.length - cut).join(' ') + ' ';
        tail = words.slice(words.length - cut).join(' ');
      }
      if (!tail || !tail.trim()) { h.setAttribute('data-hacc', '1'); return; }

      // veilig opbouwen (geen innerHTML-injectie van rauwe tekst): textNode + span.
      h.textContent = '';
      h.appendChild(doc.createTextNode(head));
      var span = doc.createElement('span');
      span.className = 'thin r';
      span.textContent = tail;
      h.appendChild(span);
      h.setAttribute('data-hacc', '1');
    });
  }

  function wireAll(scope) {
    scope = scope || doc;
    try { qa(scope, '[data-mnt-hero]').forEach(initHero); } catch (e) {}
    try { qa(scope, '[data-mnt-rail], [data-rail]').forEach(initRail); } catch (e) {}
    try { qa(scope, '.mnt-imgrow.overlay').forEach(initScrollPips); } catch (e) {}
    try { qa(scope, '.mbx-gallery').forEach(initGalleryPips); } catch (e) {}
    try { initHeader(); } catch (e) {}
    try { initFooter(); } catch (e) {}
    try { initSheet(); } catch (e) {}
    try { initGrabDismiss(); } catch (e) {}
    try { initAccordionRows(); } catch (e) {}
    try { initBuybox(scope); } catch (e) {}
    try { initStickyATC(scope); } catch (e) {}
    try { qa(scope, '[data-mnt-waitlist]').forEach(initWaitlist); } catch (e) {}
    try { qa(scope, '[data-mnt-col]').forEach(initColFilter); } catch (e) {}
    try { qa(scope, '[data-mnt-col]').forEach(initColSheet); } catch (e) {}
    try { qa(scope, '[data-mnt-faq]').forEach(initFaq); } catch (e) {}
    try { initHeadAccent(scope); } catch (e) {}
  }

  /* ═══════════ FAQ (sections/menta-faq.liquid) — verplaatst uit de surface (was self-sufficient
     met eigen <script>). Accordion-toggle (MEERDERE mogen open — bewust, geen max-1-open), deep-link
     (opent de eerste vraag van een categorie bij #hash), mobiele pill-nav + desktop zij-nav scroll-spy.
     Reveal NIET hier: [data-rv] draait op de sitewide reveal-engine (initReveal). Idempotent. ═══════════ */
  function initFaq(root) {
    if (!root || root.__mfaqWired) return; root.__mfaqWired = true;

    /* ── ACCORDEON — meerdere open toegestaan (twee antwoorden naast elkaar leggen) ── */
    on(root, 'click', function (e) {
      var b = e.target.closest ? e.target.closest('.mfaq-q') : null; if (!b) return;
      var i = b.closest('.mfaq-i'); if (!i) return;
      if (i.hasAttribute('data-on')) { i.removeAttribute('data-on'); b.setAttribute('aria-expanded', 'false'); }
      else { i.setAttribute('data-on', ''); b.setAttribute('aria-expanded', 'true'); }
    });
    qa(root, '.mfaq-q').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });

    /* ── DEEP LINK — #categorie opent de eerste vraag van die categorie ── */
    function openFirst(id) {
      if (!id || id.length < 2) return;
      var s; try { s = root.querySelector(id); } catch (err) { return; }
      if (!s) return;
      var i = s.querySelector('.mfaq-i'); if (!i) return;
      i.setAttribute('data-on', '');
      var b = i.querySelector('.mfaq-q'); if (b) b.setAttribute('aria-expanded', 'true');
    }
    if (win.location.hash) openFirst(win.location.hash);
    on(win, 'hashchange', function () { if (win.location.hash) openFirst(win.location.hash); });

    var RM = win.matchMedia && win.matchMedia('(prefers-reduced-motion:reduce)').matches;

    /* ── MOBIELE PILL-NAV — smooth-scroll met sticky-offset + scroll-spy ── */
    (function () {
      var nav = root.querySelector('[data-faqpill]'); if (!nav) return;
      var plinks = qa(nav, 'a[href^="#"]');
      var pmap = plinks.map(function (a) { var el = doc.getElementById(a.getAttribute('href').slice(1)); return el ? { a: a, el: el } : null; }).filter(Boolean);
      var stickyTop = 88;
      function navH() { return (nav.offsetHeight || 56) + stickyTop; }
      plinks.forEach(function (a) {
        on(a, 'click', function (e) {
          var el = doc.getElementById(a.getAttribute('href').slice(1)); if (!el) return;
          e.preventDefault();
          var y = el.getBoundingClientRect().top + win.pageYOffset - navH() - 8;
          win.scrollTo({ top: y, behavior: RM ? 'auto' : 'smooth' });
        });
      });
      function pspy() {
        var pos = win.pageYOffset + navH() + 40, cur = null;
        pmap.forEach(function (m) { if (m.el.offsetTop <= pos) cur = m; });
        pmap.forEach(function (m) { m.a.classList.toggle('on', m === cur); });
      }
      on(win, 'scroll', pspy, { passive: true });
      on(win, 'resize', pspy); pspy();
    })();

    /* ── DESKTOP ZIJ-NAV — scroll-spy (IntersectionObserver, bovenste derde) ── */
    var links = qa(root, '.mfaq-side-a');
    var secs = qa(root, '.mfaq-cat');
    if (secs.length && 'IntersectionObserver' in win) {
      var spy = new IntersectionObserver(function (es) {
        es.forEach(function (en) {
          if (!en.isIntersecting) return;
          var id = en.target.id;
          links.forEach(function (a) {
            if (a.getAttribute('href') === '#' + id) a.setAttribute('data-on', '');
            else a.removeAttribute('data-on');
          });
        });
      }, { rootMargin: '-12% 0px -66% 0px', threshold: 0 });
      secs.forEach(function (s) { spy.observe(s); });
    } else if (links.length) {
      links[0].setAttribute('data-on', '');
    }
  }

  /* ═══════════ COLLECTIE — client-side state/availability-filter (sections/menta-collection.liquid) ═══════════
     Bij een kleine catalogus geen server-side facets: de kaarten zijn al geladen, we tonen/verbergen
     ze op data-state / data-available. Sort blijft native (Shopify sort_by URL, aparte form). Idempotent. */
  function initColFilter(root){
    if(!root || root.getAttribute('data-col-on') === '1') return;
    var grid = root.querySelector('[data-col-grid]');
    if(!grid) return;
    root.setAttribute('data-col-on','1');
    var cards = [].slice.call(grid.querySelectorAll('.mnt-statecard'));
    /* COUNT — er kan meer dan één count-element zijn (balk + evt. sheet); werk ze allemaal bij. */
    var countEls = [].slice.call(root.querySelectorAll('[data-col-count]'));
    var noRes = root.querySelector('[data-col-noresults]');
    var endWrap = root.querySelector('[data-col-end]');
    var endCount = root.querySelector('[data-col-end-count]');
    var totalTxt = countEls.length ? countEls[0].textContent : '';
    var endTotalTxt = endCount ? endCount.textContent : '';
    var state = '', avail = '';
    function word(n){ return n + (n === 1 ? ' product' : ' products'); }
    function apply(){
      var shown = 0;
      cards.forEach(function(c){
        var okS = !state || c.getAttribute('data-state') === state;
        var okA = !avail || c.getAttribute('data-available') === avail;
        var vis = okS && okA;
        c.hidden = !vis;
        if(vis) shown++;
      });
      var active = !!(state || avail);
      var txt = active ? word(shown) : totalTxt;
      countEls.forEach(function(el){ el.textContent = txt; });
      /* einde-strook: bij een actief filter verbergen (geen 'showing all' meer), anders herstellen */
      if(endWrap) endWrap.hidden = active;
      if(endCount && !active) endCount.textContent = endTotalTxt;
      if(noRes) noRes.hidden = shown !== 0;
    }
    root.querySelectorAll('[data-col-filter]').forEach(function(inp){
      inp.addEventListener('change', function(){
        var kind = inp.getAttribute('data-col-filter');
        if(kind === 'state') state = inp.value;
        else if(kind === 'avail') avail = inp.value;
        apply();
      });
    });
    var reset = root.querySelector('[data-col-reset]');
    if(reset) reset.addEventListener('click', function(){
      state=''; avail='';
      root.querySelectorAll('input[data-col-filter][value=""]').forEach(function(r){ r.checked = true; });
      apply();
    });

    /* DENSITY-TOGGLE — klant kiest 2/3/4 per rij; keuze onthouden in localStorage. Werkt op elk
       viewport (óók mobiel). Zonder opgeslagen keuze synct 'ie alleen de highlight met het actuele
       kolom-aantal (mobiel = 2 via CSS, desktop = admin-default) — zónder inline vast te zetten,
       zodat een rotatie/resize de CSS-default blijft volgen tot de klant echt tikt. */
    (function(){
      var bar = root.querySelector('[data-col-density]');
      if(!bar || !grid) return;
      var btns = [].slice.call(bar.querySelectorAll('[data-col-cols]'));
      function highlight(n){
        btns.forEach(function(b){
          var on = b.getAttribute('data-col-cols') === String(n);
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      }
      function set(n, save){
        n = String(n);
        /* MOBIEL: max 3 kolommen (de |||| knop is verborgen op mobiel). Cap ook een opgeslagen 4 → 3. */
        if(n === '4' && window.matchMedia && window.matchMedia('(max-width:640px)').matches){ n = '3'; }
        grid.style.setProperty('--col', n);
        highlight(n);
        if(save){ try{ localStorage.setItem('mntColCols', n); }catch(e){} }
      }
      var saved = null;
      try{ saved = localStorage.getItem('mntColCols'); }catch(e){}
      if(saved && ['2','3','4'].indexOf(saved) > -1){ set(saved, false); }
      else { var cur = getComputedStyle(grid).getPropertyValue('--col').trim(); if(['2','3','4'].indexOf(cur) > -1) highlight(cur); }
      btns.forEach(function(b){ b.addEventListener('click', function(){ set(b.getAttribute('data-col-cols'), true); }); });
    })();

    /* SORT — client-side, GEEN reload (net als het filter). Herordent de al-geladen kaarten:
         · featured    = de originele DOM-volgorde = de collectie-sortering uit Shopify admin
         · price-asc   = data-price (cents) oplopend
         · price-desc  = data-price aflopend
         · best        = PRE-LAUNCH identiek aan featured (0 sales; Shopify's native best-selling
                         valt met 0 orders óók terug op de default-volgorde). ══ LATER (launch):
                         wissel 'best' naar native ?sort_by=best-selling of een popularity-metafield
                         zodra er verkoopdata is. ══
       appendChild verplaatst een bestaande node → herordent zonder her-render; het filter (hidden)
       blijft intact, ongeacht de nieuwe volgorde. */
    (function(){
      var sortInputs = [].slice.call(root.querySelectorAll('[data-col-sort]'));
      if(!sortInputs.length) return;
      var featured = cards.slice();                 /* DOM-volgorde bij init = featured/admin */
      function priceOf(c){ var v = parseInt(c.getAttribute('data-price') || '0', 10); return isNaN(v) ? 0 : v; }
      function sortBy(mode){
        var arr;
        if(mode === 'price-asc'){ arr = featured.slice().sort(function(a,b){ return priceOf(a) - priceOf(b); }); }
        else if(mode === 'price-desc'){ arr = featured.slice().sort(function(a,b){ return priceOf(b) - priceOf(a); }); }
        else { arr = featured.slice(); }            /* featured + best (pre-launch) */
        arr.forEach(function(c){ grid.appendChild(c); });
      }
      sortInputs.forEach(function(inp){
        inp.addEventListener('change', function(){ if(inp.checked) sortBy(inp.value); });
      });
    })();
  }

  /* ═══════════ COLLECTIE — MOBIELE FILTER&SORT BOTTOM-SHEET (§39c) ═══════════
     De 'Filter & Sort'-knop op de balk opent/sluit de bottom-sheet (.mnt-col-side) + overlay, met
     body-scrolllock. De radio's/sort blijven door initColFilter afgehandeld — dit is alléén de
     open/dicht-schil. Idempotent (guard). Op desktop is de sheet-chrome CSS-verborgen, dus openen
     heeft daar geen zichtbaar effect (de knop is er ook verborgen). ═══════════ */
  function initColSheet(root){
    if(!root || root.getAttribute('data-col-sheet-on') === '1') return;
    var sheet = root.querySelector('[data-col-sheet]');
    var openBtn = root.querySelector('[data-col-sheet-open]');
    if(!sheet || !openBtn) return;               /* geen filters (bv. lege collectie) → niets te doen */
    root.setAttribute('data-col-sheet-on','1');
    var ov = root.querySelector('.mnt-col-sheet-ov');
    var closers = [].slice.call(root.querySelectorAll('[data-col-sheet-close]'));
    var htmlEl = doc.documentElement;
    function open(){
      sheet.classList.add('on');
      if(ov) ov.classList.add('on');
      openBtn.setAttribute('aria-expanded','true');
      htmlEl.classList.add('mnt-col-sheet-lock');
    }
    function close(){
      sheet.classList.remove('on');
      if(ov) ov.classList.remove('on');
      openBtn.setAttribute('aria-expanded','false');
      htmlEl.classList.remove('mnt-col-sheet-lock');
    }
    openBtn.addEventListener('click', open);
    closers.forEach(function(el){ el.addEventListener('click', close); });
    /* Escape sluit; een radio-keuze laat de sheet OPEN (klant stelt meerdere filters in, sluit zelf
       met 'Show results'). */
    doc.addEventListener('keydown', function(e){ if(e.key === 'Escape' && sheet.classList.contains('on')) close(); });
  }

  /* ═══════════ SAME-TAB REDIRECT-OVERLAY (§RDR) — verhuisd uit theme.liquid.
     Toont #menta-redirect (5 bouncende state-dots) tijdens een interne navigatie: vangt clicks op
     interne <a>'s (geen #-anker, geen download, geen _blank, geen extern/mailto/tel, geen modifier-
     klik). pageshow(persisted) reset 'm bij terug-navigeren (bfcache). Idempotent. ═══════════ */
  function initRedirect() {
    var ov = doc.getElementById('menta-redirect');
    if (!ov || ov.__mntRdr) return; ov.__mntRdr = true;
    var shown = false;
    function show(){ if(shown) return; shown = true; ov.classList.add('show'); }
    on(doc, 'click', function (e) {
      var a = e.target.closest ? e.target.closest('a') : null;
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (!href || href.charAt(0) === '#') return;
      if (a.hasAttribute('download')) return;
      if (a.getAttribute('target') === '_blank') return;
      if (a.hostname && a.hostname !== win.location.hostname) return;
      if (/^(mailto:|tel:|javascript:)/i.test(href)) return;
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      show();
    }, true);
    on(win, 'pageshow', function (e) { if (e.persisted) { ov.classList.remove('show'); shown = false; } });
  }

  /* ── POLICY cookie-link ──────────────────────────────────────────────────
     Was inline in menta-policy.liquid. Zelfde patroon als de footer: het
     paneel leeft in snippets/menta-cookies.liquid en registreert
     window.MENTA_PRIVACY.open; toon de link pas als dat er is, val anders
     terug op de fallback-tekst. */
  function initPolicyCookies() {
    var b = doc.getElementById('mpolCookies');
    var f = doc.getElementById('mpolCookiesFallback');
    if (!b) return;
    function ready(){ return win.MENTA_PRIVACY && win.MENTA_PRIVACY.open; }
    function arm(){ if (ready()) { b.hidden = false; if (f) f.hidden = true; return true; } return false; }
    if (!arm()) { var n = 0, t = setInterval(function () { if (arm() || ++n > 40) clearInterval(t); }, 250); }
    b.addEventListener('click', function () { if (ready()) win.MENTA_PRIVACY.open(); });
  }

  /* ── COOKIE CONSENT ─────────────────────────────────────────────────────────
     Verhuisd uit snippets/menta-cookies.liquid (was inline <script>). De markup
     (#mprv) leeft in dat snippet, de opmaak in menta.css §CKI, en dit is het
     gedrag. COMPLIANCE-KRITISCH — de Shopify Customer Privacy API-logica is
     verbatim overgenomen (setTrackingConsent is het enige dat écht blokkeert;
     sale_of_data in een eigen call; de bar sluit altijd; answered-flag tegen de
     her-verschijn-bug). Registreert window.MENTA_PRIVACY.open voor de footer- en
     policy-cookielink. Niet aanraken zonder de regels in het snippet te lezen. */
  function initCookieConsent() {
    var el = document.getElementById('mprv');
    if (!el || el.__mntPrv) return; el.__mntPrv = true;

    var btnAll = document.getElementById('mprvAll');
    var btnNone = document.getElementById('mprvNone');
    var btnPref = document.getElementById('mprvPref');
    var btnSave = document.getElementById('mprvSave');
    var saleCat = document.getElementById('mprvSale');
    var switches = el.querySelectorAll('.mprv-sw[data-k]');

    /* de vier signalen. Niets pre-ticked; sale_of_data staat default op allowed
       omdat OPTEN-OUT daar de actie is, niet opten-in. */
    var state = { analytics: false, marketing: false, preferences: false, sale_of_data: true };

    function paint() {
      for (var i = 0; i < switches.length; i++) {
        var k = switches[i].getAttribute('data-k');
        switches[i].setAttribute('aria-checked', state[k] ? 'true' : 'false');
      }
    }
    for (var i = 0; i < switches.length; i++) {
      (function (sw) {
        sw.addEventListener('click', function () {
          var k = sw.getAttribute('data-k');
          state[k] = !state[k];
          paint();
        });
      })(switches[i]);
    }

    function open() {
      el.hidden = false;
      el.classList.add('on');
      document.body.classList.add('mprv-open');
      requestAnimationFrame(function () { el.classList.add('in'); });
    }
    function close() {
      el.classList.remove('in');
      document.body.classList.remove('mprv-open');
      setTimeout(function () {
        el.classList.remove('on', 'pref');
        el.hidden = true;
        if (btnPref) btnPref.setAttribute('aria-expanded', 'false');
      }, 420);
    }

    if (btnPref) btnPref.addEventListener('click', function () {
      var on = el.classList.toggle('pref');
      btnPref.setAttribute('aria-expanded', on ? 'true' : 'false');
    });

    /* ── HET ENIGE DAT ÉCHT IETS BLOKKEERT. setTrackingConsent is wat Shopify-
       managed surfaces gehoorzamen (pixels, audiences, checkout). sale_of_data
       gaat in een EIGEN call (docs: "instead of", niet ernaast). De bar sluit
       ALTIJD — een klik zonder zichtbaar effect is het slechtste. Callback die
       nooit vuurt wordt door de timeout gevangen. ── */
    var busy = false, saleRegion = false;
    var FLAG = 'mprv-answered', YEAR = 365 * 24 * 60 * 60 * 1000;

    function answered() {
      try {
        var v = localStorage.getItem(FLAG);
        if (!v) return false;
        if (Date.now() - parseInt(v, 10) > YEAR) { localStorage.removeItem(FLAG); return false; }
        return true;
      } catch (e) { return false; }
    }
    function markAnswered() {
      try { localStorage.setItem(FLAG, String(Date.now())); } catch (e) {}
    }

    var DEBUG = false;
    try {
      DEBUG = location.search.indexOf('mprvdebug') > -1 ||
              localStorage.getItem('mprv-debug') === '1';
    } catch (e) {}
    function log() {
      if (!DEBUG) return;
      var a = Array.prototype.slice.call(arguments);
      a.unshift('[MENTA]');
      console.log.apply(console, a);
    }
    function snapshot(when) {
      if (!DEBUG) return;
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) { log(when, 'customerPrivacy MISSING'); return; }
      var out = {};
      try { out.shouldShowBanner = cp.shouldShowBanner && cp.shouldShowBanner(); } catch (e) { out.shouldShowBanner = 'threw: ' + e; }
      try { out.currentVisitorConsent = cp.currentVisitorConsent && cp.currentVisitorConsent(); } catch (e) { out.currentVisitorConsent = 'threw: ' + e; }
      try { out.saleOfDataRegion = cp.saleOfDataRegion && cp.saleOfDataRegion(); } catch (e) {}
      try { out.analyticsProcessingAllowed = cp.analyticsProcessingAllowed && cp.analyticsProcessingAllowed(); } catch (e) {}
      log(when, out);
    }

    function lock(on) {
      [btnAll, btnNone, btnSave].forEach(function (b) { if (b) b.disabled = on; });
    }

    function apply() {
      if (busy) return;
      busy = true; lock(true);
      markAnswered();

      var settled = false;
      function finish() {
        if (settled) return;
        settled = true; busy = false; lock(false);
        setTimeout(function () { snapshot('after setTrackingConsent'); }, 250);
        close();
      }
      var net = setTimeout(function () {
        log('callback never fired within 3s — closing anyway');
        finish();
      }, 3000);

      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp || !cp.setTrackingConsent) {
        console.warn('[MENTA] Customer Privacy API unavailable — consent not stored');
        clearTimeout(net); finish(); return;
      }

      var calls = [{
        analytics: state.analytics,
        marketing: state.marketing,
        preferences: state.preferences
      }];
      if (saleRegion) calls.push({ sale_of_data: state.sale_of_data });

      var pending = calls.length;
      function step(r) {
        log('setTrackingConsent returned', r);
        if (r && r.error) console.warn('[MENTA] consent not stored:', r.error);
        if (--pending <= 0) { clearTimeout(net); finish(); }
      }

      for (var n = 0; n < calls.length; n++) {
        log('setTrackingConsent →', calls[n]);
        try { cp.setTrackingConsent(calls[n], step); }
        catch (e) { console.warn('[MENTA] consent call threw:', e); step({ error: String(e) }); }
      }
    }

    if (btnAll) btnAll.addEventListener('click', function () {
      state = { analytics: true, marketing: true, preferences: true, sale_of_data: true };
      paint(); apply();
    });
    if (btnNone) btnNone.addEventListener('click', function () {
      state = { analytics: false, marketing: false, preferences: false, sale_of_data: false };
      paint(); apply();
    });
    if (btnSave) btnSave.addEventListener('click', apply);

    function cboot() {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (!cp) return;

      try {
        saleRegion = !!(cp.saleOfDataRegion && cp.saleOfDataRegion());
        if (saleCat && saleRegion) saleCat.hidden = false;
      } catch (e) {}

      try {
        var c = cp.currentVisitorConsent && cp.currentVisitorConsent();
        if (c) {
          if (c.analytics) state.analytics = c.analytics === 'yes';
          if (c.marketing) state.marketing = c.marketing === 'yes';
          if (c.preferences) state.preferences = c.preferences === 'yes';
          if (c.sale_of_data) state.sale_of_data = c.sale_of_data !== 'no';
          paint();
        }
      } catch (e) {}

      snapshot('on load');

      try {
        var show = cp.shouldShowBanner && cp.shouldShowBanner();
        var seen = answered();
        log('shouldShowBanner →', show, '| answered before →', seen);
        if (show && seen) {
          console.warn('[MENTA] Shopify still reports shouldShowBanner() = true even though ' +
            'this visitor already answered — the choice is not being persisted on Shopify\'s side. ' +
            'The banner stays down (nothing is tracked without consent), but this is worth fixing. ' +
            'Add ?mprvdebug to the URL for the full trace.');
        }
        if (show && !seen) open();
      } catch (e) { log('shouldShowBanner threw', e); }
    }

    if (window.Shopify && window.Shopify.loadFeatures) {
      window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], function (err) {
        if (err) { console.warn('[MENTA] consent API failed to load:', err); return; }
        log('consent-tracking-api loaded');
        cboot();
      });
    } else {
      console.warn('[MENTA] window.Shopify.loadFeatures is missing — is the menta-cookies snippet rendered ' +
        'inside layout/theme.liquid, before </body>?');
    }

    /* Withdrawing has to be as easy as giving. De footer- en policy-cookielink
       roepen dit aan. */
    window.MENTA_PRIVACY = {
      open: function () {
        open(); el.classList.add('pref');
        if (btnPref) btnPref.setAttribute('aria-expanded', 'true');
      },
      close: close,
      reset: function () {
        try { localStorage.removeItem(FLAG); } catch (e) {}
        console.log('[MENTA] answered-flag cleared — reload to see the banner');
      }
    };
  }

  function boot() {
    wireAll(doc);
    try { initReveal(); } catch (e) {}
    try { initRedirect(); } catch (e) {}
    try { initCookieConsent(); } catch (e) {}
    try { initPolicyCookies(); } catch (e) {}
    /* Smooth-scroll pas ná de eerste paint aanzetten (menta.css §8: html.smooth-ready).
       Zo is de scroll bij page-load INSTANT — de browser-scrollrestore wordt niet
       geanimeerd, dus op lange pagina's (Evidence) "vecht" je eerste scroll niet meer.
       Anker-links (nav → #cognitive etc.) glijden dáárna wél smooth. Dubbele rAF = na
       de eerste echte frame. */
    try {
      (win.requestAnimationFrame || function (f) { return setTimeout(f, 32); })(function () {
        (win.requestAnimationFrame || function (f) { return setTimeout(f, 32); })(function () {
          doc.documentElement.classList.add('smooth-ready');
        });
      });
    } catch (e) { doc.documentElement.classList.add('smooth-ready'); }
  }

  if (doc.readyState === 'loading') {
    on(doc, 'DOMContentLoaded', boot);
  } else {
    boot();
  }

  // Shopify theme-editor: a section can be re-rendered; re-wire the new markup.
  on(doc, 'shopify:section:load', function (e) {
    var scope = (e && e.target) || doc;
    wireAll(scope);
    try { initReveal(); } catch (err) {}
  });

})();


/* ══════════════════════════════════════════════════════════════════════════════
   CART-ENGINE (§CART) — verbatim verplaatst uit sections/menta-cart-drawer.liquid
   (2 sep 2026). Eén globale bron i.p.v. per-file JS → geen drift; een PDP of andere
   buybox roept straks gewoon window.MENTACart.addItem() of post een /cart/add-form.
   BYTE-IDENTIEK: window.MENTACart-API, fetch/XHR/submit-patches, request-sequencing,
   free-claim-lock (vol-01 + prijs 0), cross-sell (available→add / else→notify),
   selling-plan-parsing, checkout. Eigen IIFE + eigen guards (if(!drawer) return) →
   draait alleen als de cart-markup in de DOM staat, idempotent, section-reload-safe.
   Cross-file hooks (#mentaCartBtn · .menta-cart-count · #mhxCartCount · [data-cart-count]
   · [data-menta-cart-open]) ONGEWIJZIGD. Interne #mdw*-IDs behouden (interne prefix,
   matcht de cart-HTML-hooks; hernoemen = risico zonder functioneel voordeel).
   ══════════════════════════════════════════════════════════════════════════════ */
(function(){
  'use strict';

  var drawer  = document.getElementById('mdwDrawer');
  var overlay = document.getElementById('mdwOv');
  if(!drawer || !overlay) return;

  /* ═══════════ escape de Shopify overflow-parent ═══════════
     Section-wrappers hebben vaak overflow/transform → position:fixed breekt.
     Alles wat fixed moet zijn verhuist naar <body>. Eén keer, idempotent. */
  var toast = document.getElementById('mdwToast');
  [overlay, drawer, toast].forEach(function(el){
    if(el && el.parentElement !== document.body) document.body.appendChild(el);
  });

  /* ═══════════ refs ═══════════ */
  var $ = function(id){ return document.getElementById(id); };
  var elScroll = $('mdwScroll'), elItems = $('mdwItems'), elEmpty = $('mdwEmpty'),
      elFoot   = $('mdwFoot'),   elCount = $('mdwCount'),
      elShip   = $('mdwShip'),   elShipTxt = $('mdwShipTxt'), elShipFill = $('mdwShipFill'),
      elCross  = $('mdwCross'),  elCrossList = $('mdwCrossList'), elCrossData = $('mdwCrossData'),
      elSub    = $('mdwSub'),    elTotal = $('mdwTotal'),
      elSaveRow= $('mdwSaveRow'),elSaveK = $('mdwSaveK'), elSaveV = $('mdwSaveV'),
      elDiscOn = $('mdwDiscOn'), elDiscCode = $('mdwDiscCode'),
      elDiscIn = $('mdwDiscIn'), elDiscGo = $('mdwDiscGo'), elDiscMsg = $('mdwDiscMsg'),
      elNote   = $('mdwNote'),   elNoteTx = $('mdwNoteTx'), elNoteHint = $('mdwNoteHint'),
      elForm   = $('mdwForm'),   elGo = $('mdwGo');

  var SHIP_ON   = drawer.getAttribute('data-ship') === '1';
  var THRESHOLD = (parseFloat(drawer.getAttribute('data-threshold')) || 0) * 100;
  var DESC      = drawer.getAttribute('data-descriptor') || '';

  /* ═══════════ money — Shopify format, geen HTML-entities ═══════════ */
  /* fallback = EU/NL formaat (1.234,56) → amount_with_comma_separator.
     Altijd het echte €-teken — een HTML-entity decodeert niet in JS. */
  var FMT = (window.Shopify && window.Shopify.money_format) ? window.Shopify.money_format : '€{{amount_with_comma_separator}}';
  function decodeEnt(s){
    if(s.indexOf('&') === -1) return s;
    var t = document.createElement('textarea'); t.innerHTML = s; return t.value;
  }
  FMT = decodeEnt(FMT);
  function money(cents){
    var n = (cents || 0) / 100;
    function group(str, thousand, decimal){
      var p = str.split('.');
      var i = p[0].replace(/(\d)(?=(\d\d\d)+$)/g, '$1' + thousand);
      return p[1] ? i + decimal + p[1] : i;
    }
    /* Shopify's eigen definities — NIET omdraaien:
       amount = 1,134.65 (komma-duizend, punt-decimaal)
       amount_with_comma_separator = 1.134,65 (het EU/NL formaat) */
    return FMT.replace(/\{\{\s*(\w+)\s*\}\}/g, function(m, key){
      switch(key){
        case 'amount':                                  return group(n.toFixed(2), ',', '.');
        case 'amount_no_decimals':                      return group(Math.round(n).toFixed(0), ',', '.');
        case 'amount_with_comma_separator':             return group(n.toFixed(2), '.', ',');
        case 'amount_no_decimals_with_comma_separator': return group(Math.round(n).toFixed(0), '.', ',');
        case 'amount_with_apostrophe_separator':        return group(n.toFixed(2), '’', '.');
        case 'amount_with_space_separator':             return group(n.toFixed(2), ' ', ',');
        case 'amount_with_period_and_space_separator':  return group(n.toFixed(2), ' ', '.');
        default:                                        return group(n.toFixed(2), ',', '.');
      }
    });
  }

  /* ═══════════ state-map — de enige plek waar handle → kleur/glyph gaat ═══════════ */
  var STATES = {
    flow:    {hex:'#2DD4BF', t:'45,212,191', tx:'#03A692',  g:'α', label:'Flow'},
    focus:   {hex:'#FF3B5C', t:'255,59,92', tx:'#EE0028',   g:'β', label:'Focus'},
    control: {hex:'#FF8C42', t:'255,140,66', tx:'#FB6200',  g:'γ', label:'Control'},
    rest:    {hex:'#60AFFF', t:'96,175,255', tx:'#2D95FF',  g:'θ', label:'Rest'},
    reset:   {hex:'#9B7FD0', t:'155,127,208', tx:'#A67FEE', g:'δ', label:'Reset'},
    library: {hex:'#0A0A0A', t:'10,10,10', tx:'#0A0A0A',    g:'§', label:'The Library'},
    plain:   {hex:'#0A0A0A', t:'10,10,10',    g:'§', label:''}
  };
  /* guide-volumes lenen de state-kleur van hun onderwerp */
  var VOL_STATE = {'vol-03':'reset','vol-04':'control','vol-05':'flow','vol-06':'focus','vol-07':'rest','vol-08':'control'};
  var VOL_ROMAN = {'vol-01':'I','vol-02':'II','vol-03':'III','vol-04':'IV','vol-05':'V','vol-06':'VI','vol-07':'VII','vol-08':'VIII','vol-09':'IX'};

  function meta(handle){
    var h = String(handle || '').toLowerCase();
    var key = null, isGuide = false, roman = '';

    for(var v in VOL_ROMAN){ if(h.indexOf(v) > -1){ isGuide = true; roman = VOL_ROMAN[v]; if(VOL_STATE[v]) key = VOL_STATE[v]; break; } }
    if(!isGuide && h.indexOf('guide') > -1) isGuide = true;

    if(!key){
      if(h.indexOf('focus')   > -1) key = 'focus';
      else if(h.indexOf('flow')    > -1) key = 'flow';
      else if(h.indexOf('control') > -1) key = 'control';
      else if(h.indexOf('reset')   > -1) key = 'reset';   /* reset vóór rest — 'reset' bevat geen 'rest', maar wel omgekeerde valkuil vermijden */
      else if(h.indexOf('rest')    > -1) key = 'rest';
    }

    var s = STATES[key || (isGuide ? 'library' : 'plain')];
    return {
      hex: s.hex, t: s.t, g: s.g,
      label: isGuide ? 'The Library' : s.label,
      state: key,
      guide: isGuide,
      roman: roman
    };
  }

  /* MENTA <State> lockup als de titel dat toelaat, anders platte titel */
  function nameHTML(title, m, cls){
    var t = String(title || '');
    /* CANON (11 sep): geen 'MENTA'-brand-prefix meer in de cart — de cart is al de MENTA-cart,
       de prefix was ruis. Alleen de state-naam ('Focus'), in het state-card-naam-register (.s).
       'MENTA ' wordt van de titel gestript zodat 'Focus' overblijft; niet-states tonen de volle titel. */
    if(m.state && /^MENTA\s+/i.test(t)){
      var s = t.replace(/^MENTA\s+/i, '');
      return '<span class="' + cls + '"><span class="s">' + esc(s) + '</span></span>';
    }
    return '<span class="' + cls + '-plain">' + esc(t) + '</span>';
  }
  function esc(s){
    return String(s == null ? '' : s)
      .replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;')
      .replace(/"/g,'&quot;').replace(/'/g,'&#39;');
  }
  /* ── SUBSCRIPTION-LABEL NORMALISATIE ──────────────────────────────────────
     ⚠️ De selling-plan NAAM van Shopify is de bron van 'Elke 4 weken bezorgen,
        15% korting' — Nederlands, met de korting erin, en NERGENS te wijzigen:
        de winkel heeft één locale (en), dus er is niets om naar te vertalen, en
        de plannaam ligt vast bij het aanmaken van de selling-plan group. Daarom
        tonen we die naam NIET rauw. We halen alleen het GETAL + de EENHEID eruit
        (taal-agnostisch: cijfer + week/maand/day in welke taal dan ook) en
        renderen zelf nette Engelse descriptor-tekst.
     ⚠️ PUUR DE DESCRIPTOR — geen korting/prijs in de sub-regel. De prijs is
        dynamisch en leeft in de prijskolom (mdw-pr); een 'Save 15%' hier zou het
        bedrag dubbel-framen. De sub-regel zegt WAT je krijgt, niet wat het kost.
     ⚠️ Geeft de plan geen leesbaar interval, dan valt het terug op 'Subscription'
        zonder verzonnen frequentie — nooit gokken. ── */
  /* het TYPE-label (regel 2): Subscription · every 4 weeks · óf One-time.
     Voorkeur = de GESTRUCTUREERDE delivery_policy (interval + interval_count) die
     /cart.js op de allocation zet — taal-onafhankelijk en exact (geverifieerd:
     WEEK/4 op deze store). Valt terug op het parsen van de plannaam als /cart.js
     die policy niet meelevert. Nooit de rauwe NL-plannaam tonen. */
  function typeLabel(item){
    var alloc = item.selling_plan_allocation;
    if(!alloc) return 'One&#8209;time';
    var sp = alloc.selling_plan || {};
    var dp = sp.delivery_policy || {};
    var n = null, unit = null;
    if(dp.interval && dp.interval_count){
      n = String(dp.interval_count);
      var iv = String(dp.interval).toLowerCase();
      unit = iv.indexOf('month') > -1 ? 'month' : iv.indexOf('day') > -1 ? 'day' : 'week';
    } else {
      var m1 = String(sp.name || sp.description || '').match(/(\d+)\s*(week|weken|wk|month|maand|maanden|day|dag|dagen)/i);
      if(m1){
        n = m1[1];
        var u = m1[2].toLowerCase();
        unit = (u.indexOf('month') > -1 || u.indexOf('maand') > -1) ? 'month'
             : (u.indexOf('day')   > -1 || u.indexOf('dag')   > -1) ? 'day' : 'week';
      }
    }
    if(n && unit) return 'Subscription &middot; every ' + n + ' ' + unit + (n === '1' ? '' : 's');
    return 'Subscription';
  }
  /* de DESCRIPTOR (regel 1): wat het product IS — voor MENTA-states altijd de
     descriptor, voor guides de volume-regel, anders variant/descriptor. */
  function descLine(item, m){
    if(m.roman)  return 'A MENTA guide &middot; Vol. ' + m.roman;
    if(m.guide)  return 'A MENTA guide';
    if(item.variant_title && item.variant_title !== 'Default Title') return esc(item.variant_title);
    return esc(DESC);
  }
  /* ÉÉN rustige descriptor-regel (canon 11 sep): '30 servings · Subscription, every 4 weeks' —
     de hoeveelheid + hoe geleverd, samen op één Geist-regel (state-card cue-register). Was twee
     losse regels (descriptor + mono-caps type) — dat las te druk voor een premium cart-item.
     De DESC bevat 'Cognitive nutrition · 30 servings'; we tonen alleen het servings-deel (de
     'cognitive nutrition'-claim hoort op de PDP, niet in de cart) + het purchase-type. */
  function subLine(item, m){
    var d = descLine(item, m);
    // strip een 'Cognitive nutrition · ' voorloop zodat alleen '30 servings' overblijft
    var servings = d.replace(/^.*?[·|]\s*/, '').trim() || d;
    var parts = [];
    if(servings) parts.push(servings);
    var t = typeLabel(item);
    if(t) parts.push(t.replace(/\s*&middot;\s*/g, ', '));   // 'Subscription · every 4 weeks' → 'Subscription, every 4 weeks'
    return '<span class="l1">' + parts.join(' &middot; ') + '</span>';
  }
  /* free-claim lock — alleen de échte gratis Vol.01 */
  function isFreeClaim(handle, price){
    return price === 0 && String(handle || '').toLowerCase().indexOf('vol-01') > -1;
  }

  /* ═══════════ SVG kit ═══════════ */
  var ARW   = '<svg class="mdw-arw" viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var MINUS = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var PLUS  = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M12 5v14M5 12h14" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
  var TRASH = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M4 7h16M9 7V5a1 1 0 011-1h4a1 1 0 011 1v2m2 0v12a1 1 0 01-1 1H8a1 1 0 01-1-1V7M10 11v6M14 11v6" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var LOCK  = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><rect x="4" y="11" width="16" height="9" rx="2" stroke="currentColor" stroke-width="1.7"/><path d="M8 11V7.5a4 4 0 018 0V11" stroke="currentColor" stroke-width="1.7" stroke-linecap="round"/></svg>';
  var CHECK = '<svg viewBox="0 0 24 24" fill="none" aria-hidden="true"><path d="M20 6L9 17l-5-5" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  /* ═══════════ request-sequencing ═══════════
     Elke mutatie krijgt een token. paint() weigert een cart die ouder is dan
     de laatst gestarte mutatie → late responses kunnen nooit terugdraaien. */
  var seq = 0, painted = -1, busyCount = 0;
  function busy(on){
    busyCount = Math.max(0, busyCount + (on ? 1 : -1));
    drawer.classList.toggle('busy', busyCount > 0);
  }
  function req(url, body){
    var opt = {
      method: body ? 'POST' : 'GET',
      headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      credentials: 'same-origin'
    };
    if(body){ opt.headers['Content-Type'] = 'application/json'; opt.body = JSON.stringify(body); }
    return fetch(url, opt).then(function(r){
      return r.json().then(function(j){
        if(!r.ok){ var e = new Error(j && (j.description || j.message) || 'Cart error'); e.data = j; e.status = r.status; throw e; }
        return j;
      });
    });
  }

  /* ═══════════ TOAST ═══════════ */
  var toastTimer = null;
  function say(msg){
    if(!toast) return;
    toast.textContent = msg;
    toast.classList.add('on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function(){ toast.classList.remove('on'); }, 2600);
  }

  /* ═══════════ RENDER ═══════════ */
  function itemHTML(it){
    var m    = meta(it.handle);
    var free = isFreeClaim(it.handle, it.final_price);
    var key  = esc(it.key);

    var media = it.image
      ? '<img src="' + esc(sized(it.image, 128)) + '" alt="" loading="lazy" width="64" height="64">'
      : '<span class="mdw-glyph">' + m.g + '</span>';

    var ctrl = free
      ? '<span class="mdw-lock">' + LOCK + 'One per member</span>'
      : '<span class="mdw-qty">'
        + '<button type="button" data-q="-1" data-key="' + key + '" aria-label="Decrease quantity">' + MINUS + '</button>'
        + '<span class="v">' + it.quantity + '</span>'
        + '<button type="button" data-q="1" data-key="' + key + '" aria-label="Increase quantity">' + PLUS + '</button>'
        + '</span>';

    /* prijskolom, dynamisch: doorgestreepte was-prijs + het bespaarde bedrag als
       aparte accent-regel bij een korting. Twee bronnen van korting:
       (a) subscription/selling-plan: de line's original_line_price is dan al de
           plan-prijs, dus vergelijk tegen de VOLLE variant-prijs (it.price zonder plan);
       (b) gewone line-discount: original_line_price vs final_line_price.
       We nemen de grootste geldige 'was' zodat de strike altijd de volle prijs toont. */
    var qty = it.quantity || 1;
    var finalLine = it.final_line_price;
    /* volle 'was'-regelprijs bepalen uit de meest betrouwbare bron:
       1) selling-plan: allocation.compare_at_price is de VOLLE unit-prijs vóór de plan-korting;
       2) gewone line-discount: original_line_price;
       3) variant compare_at_price (echte compare-at op de variant).
       We nemen de hoogste geldige waarde zodat de strike altijd de volle prijs toont. */
    var fullLine = 0;
    var spa = it.selling_plan_allocation;
    if (spa && spa.compare_at_price) fullLine = spa.compare_at_price * qty;
    if (it.original_line_price > fullLine) fullLine = it.original_line_price;
    if (it.variant && it.variant.compare_at_price && it.variant.compare_at_price * qty > fullLine) fullLine = it.variant.compare_at_price * qty;
    if (!fullLine) fullLine = it.original_line_price;
    var hasDisc = !free && fullLine > finalLine;
    var saved   = fullLine - finalLine;
    /* PRIJS-CANON (11 sep): één rustig register — nu-prijs eerst (ink), was-prijs doorgestreept
       ernaast (faint). GEEN 'Save …'-mono-sticker meer: de doorgestreepte prijs communiceert de
       korting al, en de sticker brak de premium rust. Alles Geist, één gewicht-hiërarchie. */
    var price = (free ? '<span class="fr">Free</span>' : '<span class="fr">' + money(finalLine) + '</span>')
      + (hasDisc ? '<s>' + money(fullLine) + '</s>' : '');

    /* dfyne-rij: media (row-span) · info-kolom (naam → variant/type → prijs → controls-rij).
       De controls-rij draagt de qty-pill links en de trash rechts. De prijs staat nu IN de
       info-flow (onder de variant), niet in een aparte rechter-kolom. Alle class/data-hooks
       ongewijzigd (mdw-item/media/info/nm/sub/pr/qty/rm · data-key/data-rm/data-q). */
    return '<div class="mdw-item" data-key="' + key + '" style="--sc:' + m.hex + ';--sc-t:' + m.t + ';--sc-tx:' + (m.tx||m.hex) + '">'
      +   '<a class="mdw-media" href="' + esc(it.url) + '" aria-hidden="true" tabindex="-1">' + media + '</a>'
      +   '<div class="mdw-info">'
      +     '<a href="' + esc(it.url) + '">' + nameHTML(it.product_title, m, 'mdw-nm') + '</a>'
      +     '<span class="mdw-sub">' + subLine(it, m) + '</span>'
      +     '<span class="mdw-pr">' + price + '</span>'
      +     '<div class="mdw-ctrl">' + ctrl
      +       '<button type="button" class="mdw-rm" data-rm="' + key + '" aria-label="Remove ' + esc(it.product_title) + '">' + TRASH + '</button>'
      +     '</div>'
      +   '</div>'
      + '</div>';
  }
  /* Shopify CDN size-injectie, veilig bij query-strings */
  function sized(url, w){
    if(!url) return '';
    if(url.indexOf('/cdn/') === -1 && url.indexOf('cdn.shopify') === -1) return url;
    return url.replace(/(\.(?:png|jpe?g|webp|gif|avif))(\?|$)/i, '_' + w + 'x$1$2');
  }

  var CROSS = [];
  if(elCrossData){ try { CROSS = JSON.parse(elCrossData.textContent) || []; } catch(e){ CROSS = []; } }

  function paintCross(cart){
    if(!elCross || !elCrossList) return;
    var inCart = {};
    cart.items.forEach(function(it){ inCart[it.product_id] = 1; });

    var rows = CROSS.filter(function(p){ return !inCart[p.id]; }).slice(0, 4).map(function(p){
      var m = meta(p.handle);
      var media = p.img
        ? '<img src="' + esc(p.img) + '" alt="" loading="lazy" draggable="false">'
        : '<span class="g">' + m.g + '</span>';
      var price = p.free ? 'Free' : (p.price ? esc(p.price) + (p.compare ? '<s>' + esc(p.compare) + '</s>' : '') : '');
      /* voorraad = de schakelaar */
      var cta = p.available
        ? '<button type="button" class="mdw-cx-btn" data-add="' + esc(p.vid) + '" data-free="' + (p.free ? '1' : '0') + '">'
          + (p.free ? 'Claim' : 'Add') + ARW + '</button>'
        : '<a class="mdw-cx-btn" href="' + esc(p.url) + '">Notify me' + ARW + '</a>';

      return '<div class="mdw-cx" style="--sc:' + m.hex + ';--sc-t:' + m.t + ';--sc-tx:' + (m.tx||m.hex) + '">'
        +   '<a class="mdw-cx-media" href="' + esc(p.url) + '" aria-hidden="true" tabindex="-1">' + media + '</a>'
        +   '<div class="mdw-cx-tx"><a href="' + esc(p.url) + '">' + nameHTML(p.title, m, 'mdw-cx-nm') + '</a>'
        +     (price ? '<span class="mdw-cx-d">' + price + '</span>' : '')
        +   '</div>' + cta
        + '</div>';
    }).join('');

    if(rows){ elCrossList.innerHTML = rows; elCross.classList.remove('mdw-hide'); }
    else     { elCrossList.innerHTML = '';   elCross.classList.add('mdw-hide'); }
  }

  function paint(cart, token){
    if(!cart || typeof cart.item_count !== 'number') return;
    if(typeof token === 'number'){
      if(token < painted) return;      /* stale response — negeer */
      painted = token;
    }
    LAST = cart;

    var n = cart.item_count;
    if(elCount) elCount.textContent = n > 0 ? (n + ' item' + (n !== 1 ? 's' : '')) : '';
    syncBadge(n);

    if(n === 0){
      elScroll.classList.add('mdw-hide');
      elFoot.classList.add('mdw-hide');
      elEmpty.classList.remove('mdw-hide');
      elItems.innerHTML = '';
      return;
    }

    elEmpty.classList.add('mdw-hide');
    elScroll.classList.remove('mdw-hide');
    elFoot.classList.remove('mdw-hide');

    elItems.innerHTML = cart.items.map(itemHTML).join('');
    paintCross(cart);

    /* totals */
    if(elSub)   elSub.textContent   = money(cart.original_total_price);
    if(elTotal) elTotal.textContent = money(cart.total_price);

    var saved = (cart.original_total_price || 0) - (cart.total_price || 0);
    if(elSaveRow){
      if(saved > 0){
        elSaveRow.classList.remove('mdw-hide');
        var app = (cart.cart_level_discount_applications && cart.cart_level_discount_applications[0]) || null;
        elSaveK.textContent = app && app.title ? app.title : 'Discount';
        elSaveV.textContent = '−' + money(saved);
      } else {
        elSaveRow.classList.add('mdw-hide');
      }
    }

    /* applied discount pill — alleen echte cart-level codes */
    var codes = (cart.cart_level_discount_applications || [])
      .filter(function(a){ return a.type === 'discount_code' || a.type === 'script'; })
      .map(function(a){ return a.title; });
    if(elDiscOn){
      if(codes.length){ elDiscOn.classList.add('on'); elDiscCode.textContent = codes.join(', '); }
      else            { elDiscOn.classList.remove('on'); elDiscCode.textContent = ''; }
    }

    /* free shipping */
    if(SHIP_ON && elShip){
      if(THRESHOLD > 0){
        elShip.classList.remove('mdw-hide');
        var left = THRESHOLD - cart.total_price;
        var pct  = Math.max(0, Math.min(100, (cart.total_price / THRESHOLD) * 100));
        elShipFill.style.width = (left <= 0 ? 100 : Math.max(2, pct)) + '%';
        elShipTxt.innerHTML = left <= 0
          ? '<b>Free shipping</b> <span class="u">unlocked.</span>'
          : 'You’re <b>' + money(left) + '</b> away from free shipping.';
      } else {
        elShip.classList.add('mdw-hide');
      }
    }

    if(elGo) elGo.disabled = false;
  }

  /* header badge — één plek, alle bekende hooks */
  function syncBadge(n){
    /* ⚠️ twee notaties. De tekst-hooks staan achter het woord 'Cart' en willen
       haakjes: "Cart (2)". De ronde badge op het mobiele icoon is een pill van
       16px — daar past alleen het kale cijfer in. Vandaar [data-cart-count]
       apart. */
    document.querySelectorAll('.menta-cart-count,#mhxCartCount').forEach(function(el){
      el.textContent = '(' + n + ')';
      if(n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden','');
    });
    document.querySelectorAll('[data-cart-count]').forEach(function(el){
      el.textContent = String(n);
      if(n > 0) el.removeAttribute('hidden'); else el.setAttribute('hidden','');
    });
  }

  /* ═══════════ CART OPS ═══════════ */
  var LAST = null;

  function refresh(){
    var t = ++seq; busy(true);
    return req('/cart.js')
      .then(function(c){ paint(c, t); return c; })
      .catch(function(){ return null; })
      .then(function(c){ busy(false); return c; });
  }

  function change(key, qty, row){
    var t = ++seq; busy(true);
    if(row) row.classList.add('busy');
    return req('/cart/change.js', {id: key, quantity: qty})
      .then(function(c){ paint(c, t); })
      .catch(function(err){ say(err && err.message ? err.message : 'Could not update'); return refresh(); })
      .then(function(){ busy(false); });
  }

  function addItem(id, qty, opts){
    opts = opts || {};
    var t = ++seq; busy(true);
    var payload = {items: [{id: id, quantity: qty || 1}]};
    if(opts.properties) payload.items[0].properties = opts.properties;
    if(opts.selling_plan) payload.items[0].selling_plan = opts.selling_plan;

    return req('/cart/add.js', payload)
      .then(function(){ return req('/cart.js'); })
      .then(function(c){ paint(c, t); open(); return c; })
      .catch(function(err){ say(err && err.message ? err.message : 'Could not add to cart'); throw err; })
      .then(function(c){ busy(false); return c; }, function(e){ busy(false); throw e; });
  }

  /* ═══════════ OPEN / CLOSE + scroll-lock + focus-trap ═══════════ */
  var lockY = 0, locked = false, lastFocus = null;

  function lock(){
    if(locked) return; locked = true;
    lockY = window.pageYOffset || document.documentElement.scrollTop || 0;
    document.body.style.position = 'fixed';
    document.body.style.top   = (-lockY) + 'px';
    document.body.style.left  = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
  }
  function unlock(){
    if(!locked) return; locked = false;
    document.body.style.position = '';
    document.body.style.top = ''; document.body.style.left = '';
    document.body.style.right = ''; document.body.style.width = '';
    /* html.smooth-ready{scroll-behavior:smooth} (menta.css §8, voor anker-landing) zou dit
       herstel anders ANIMEREN. Even 'auto' forceren zodat de scroll-terug een instant sprong
       is, daarna terug zodat anker-links smooth blijven. */
    var htmlEl = document.documentElement, prevSB = htmlEl.style.scrollBehavior;
    htmlEl.style.scrollBehavior = 'auto';
    window.scrollTo(0, lockY);
    htmlEl.style.scrollBehavior = prevSB;
  }

  function open(){
    if(drawer.classList.contains('on')){ refresh(); return; }
    lastFocus = document.activeElement;
    lock();
    overlay.classList.add('on');
    drawer.classList.add('on');
    drawer.setAttribute('aria-hidden','false');
    refresh().then(function(){
      var f = drawer.querySelector('#mdwClose'); if(f) f.focus({preventScroll:true});
    });
  }
  function close(){
    if(!drawer.classList.contains('on')) return;
    drawer.classList.remove('on');
    overlay.classList.remove('on');
    drawer.setAttribute('aria-hidden','true');
    unlock();
    if(lastFocus && lastFocus.focus) lastFocus.focus({preventScroll:true});
  }

  var CLOSEBTN = $('mdwClose');
  if(CLOSEBTN) CLOSEBTN.addEventListener('click', close);
  overlay.addEventListener('click', close);

  document.addEventListener('keydown', function(e){
    if(!drawer.classList.contains('on')) return;
    if(e.key === 'Escape'){ e.preventDefault(); close(); return; }
    if(e.key !== 'Tab') return;
    var f = drawer.querySelectorAll('a[href],button:not([disabled]),input,textarea,[tabindex]:not([tabindex="-1"])');
    var vis = Array.prototype.filter.call(f, function(el){ return el.offsetParent !== null; });
    if(!vis.length) return;
    var first = vis[0], last = vis[vis.length - 1];
    if(e.shiftKey && document.activeElement === first){ e.preventDefault(); last.focus(); }
    else if(!e.shiftKey && document.activeElement === last){ e.preventDefault(); first.focus(); }
  });

  /* ═══════════ EVENT DELEGATION — items + cross-sell ═══════════ */
  drawer.addEventListener('click', function(e){
    var q = e.target.closest('[data-q]');
    if(q){
      var row = q.closest('.mdw-item');
      var v   = row && row.querySelector('.mdw-qty .v');
      var cur = v ? parseInt(v.textContent, 10) : 1;
      var nxt = cur + parseInt(q.getAttribute('data-q'), 10);
      if(nxt < 1){
        if(row) row.classList.add('out');
        var k1 = q.getAttribute('data-key');
        setTimeout(function(){ change(k1, 0, row); }, 240);
      } else {
        if(v) v.textContent = nxt;                       /* optimistic */
        change(q.getAttribute('data-key'), nxt, row);
      }
      return;
    }
    var rm = e.target.closest('[data-rm]');
    if(rm){
      var r2 = rm.closest('.mdw-item');
      if(r2) r2.classList.add('out');
      var k2 = rm.getAttribute('data-rm');
      setTimeout(function(){ change(k2, 0, r2); }, 240);
      return;
    }
    var add = e.target.closest('[data-add]');
    if(add){
      var vid = add.getAttribute('data-add');
      /* free-claim lock: nooit twee keer dezelfde gratis Vol.01 */
      if(add.getAttribute('data-free') === '1' && LAST){
        var has = LAST.items.some(function(it){
          return String(it.variant_id) === String(vid) && isFreeClaim(it.handle, it.final_price);
        });
        if(has){ say('Already claimed'); return; }
      }
      add.classList.add('done');
      add.innerHTML = 'Added' + CHECK;
      addItem(vid, 1).catch(function(){});
    }
  });

  /* ═══════════ DISCOUNT ═══════════ */
  if(elDiscGo){
    var apply = function(){
      var code = (elDiscIn.value || '').trim();
      if(!code) return;
      elDiscMsg.textContent = 'Applying…';
      elDiscMsg.classList.remove('err');
      elDiscGo.disabled = true;
      var t = ++seq; busy(true);
      req('/cart/update.js', {discount: code})
        .then(function(c){
          var ok = (c.cart_level_discount_applications || []).some(function(a){
            return String(a.title).toLowerCase() === code.toLowerCase();
          }) || (c.total_discount > 0) || (c.items || []).some(function(i){ return (i.line_level_discount_allocations||[]).length; });
          paint(c, t);
          if(ok){ elDiscMsg.textContent = ''; elDiscIn.value = ''; }
          else  { elDiscMsg.textContent = 'This code isn’t valid.'; elDiscMsg.classList.add('err'); }
        })
        .catch(function(){ elDiscMsg.textContent = 'Something went wrong. Try again.'; elDiscMsg.classList.add('err'); })
        .then(function(){ elDiscGo.disabled = false; busy(false); });
    };
    elDiscGo.addEventListener('click', apply);
    elDiscIn.addEventListener('keydown', function(e){ if(e.key === 'Enter'){ e.preventDefault(); apply(); } });
    elDiscIn.addEventListener('input', function(){ elDiscMsg.textContent = ''; elDiscMsg.classList.remove('err'); });
  }
  var discOff = $('mdwDiscOff');
  if(discOff) discOff.addEventListener('click', function(){
    var t = ++seq; busy(true);
    req('/cart/update.js', {discount: ''})
      .then(function(c){ paint(c, t); })
      .catch(function(){ return refresh(); })
      .then(function(){ busy(false); });
  });

  /* ═══════════ NOTE ═══════════ */
  var noteQ = $('mdwNoteQ'), elNoteA = $('mdwNoteA');
  if(noteQ && elNote && elNoteA){
    /* meet de echte hoogte vóór het openen → transition loopt naar een exacte
       waarde. Na de animatie op 'auto' zetten zodat de textarea kan groeien. */
    var noteAnim = null;
    noteQ.addEventListener('click', function(){
      clearTimeout(noteAnim);
      var opening = !elNote.classList.contains('on');
      noteQ.setAttribute('aria-expanded', opening ? 'true' : 'false');
      elNote.classList.add('anim');                 /* will-change alleen tijdens de animatie */

      if(opening){
        elNoteA.style.height = 'auto';
        var h = elNoteA.scrollHeight;
        elNoteA.style.height = '0px';
        elNoteA.offsetHeight;                       /* force reflow */
        elNote.style.setProperty('--h', h + 'px');
        elNote.classList.add('on');
        elNoteA.style.height = '';                  /* CSS neemt --h over */
        noteAnim = setTimeout(function(){
          elNote.classList.remove('anim');
          if(elNote.classList.contains('on')) elNoteA.style.height = 'auto';
        }, 470);
        if(elNoteTx) setTimeout(function(){ elNoteTx.focus({preventScroll:true}); }, 200);
      } else {
        elNoteA.style.height = elNoteA.scrollHeight + 'px';
        elNoteA.offsetHeight;
        elNote.classList.remove('on');
        elNoteA.style.height = '';                  /* → terug naar 0 via CSS */
        noteAnim = setTimeout(function(){ elNote.classList.remove('anim'); }, 470);
      }
    });
  }
  if(elNoteTx){
    var noteT = null, lastNote = elNoteTx.value;
    var saveNote = function(){
      if(elNoteTx.value === lastNote) return;
      lastNote = elNoteTx.value;
      req('/cart/update.js', {note: elNoteTx.value})
        .then(function(){ if(elNoteHint){ elNoteHint.textContent = 'Saved'; setTimeout(function(){ elNoteHint.textContent = ''; }, 1800); } })
        .catch(function(){ if(elNoteHint) elNoteHint.textContent = 'Could not save'; });
    };
    elNoteTx.addEventListener('input', function(){ clearTimeout(noteT); noteT = setTimeout(saveNote, 700); });
    elNoteTx.addEventListener('blur', function(){ clearTimeout(noteT); saveNote(); });
  }

  /* ═══════════ CHECKOUT — note wegschrijven, dan direct naar Shopify checkout ═══════════
     Altijd e.preventDefault(): we navigeren zelf naar /checkout zodat de
     verwijderde /cart-pagina nooit in de flow zit. */
  if(elForm) elForm.addEventListener('submit', function(e){
    e.preventDefault();
    if(elGo) elGo.disabled = true;
    var go = function(){ window.location.href = '/checkout'; };
    if(elNoteTx && elNoteTx.value !== ''){
      req('/cart/update.js', {note: elNoteTx.value}).catch(function(){}).then(go);
    } else {
      go();
    }
  });

  /* ═══════════ OPENERS — de universele draad ═══════════
     Capture-phase, één listener op document. Alles wat naar de cart wijst opent
     de drawer: #mentaCartBtn, [data-menta-cart-open], elke /cart-link. */
  /* Alleen de échte cart-route. /cartoons, /pages/cart-info en de
     /cart/add|change|update|clear endpoints zijn géén navigatie-links. */
  function isCartHref(a){
    var h = a.getAttribute('href');
    if(!h) return false;
    if(!/^(?:https?:\/\/[^/]+)?\/cart(?:\/)?(?:[?#].*)?$/i.test(h)) return false;
    return !/\/cart\/(?:add|change|update|clear)/i.test(h);
  }
  document.addEventListener('click', function(e){
    var t = e.target.closest('#mentaCartBtn,[data-menta-cart-open],a');
    if(!t) return;
    var hit = t.id === 'mentaCartBtn' || t.hasAttribute('data-menta-cart-open')
              || (t.tagName === 'A' && isCartHref(t));
    if(!hit) return;
    if(drawer.contains(t)) return;                    /* drawer-interne links niet kapen */
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.which === 2) return;
    e.preventDefault(); e.stopPropagation();
    open();
  }, true);

  /* ═══════════ /cart bezoek → geen full cart meer ═══════════
     Er is geen cart-pagina in de UX. Wie er direct landt (bookmark, e-mail,
     Shopify-fallback) gaat terug en krijgt de drawer. */
  (function(){
    if(!/^\/cart\/?$/.test(window.location.pathname)) return;
    try { sessionStorage.setItem('mdwOpen', '1'); } catch(err){}
    var back = document.referrer && document.referrer.indexOf(window.location.origin) === 0
               && !/\/cart\/?$/.test(document.referrer) ? document.referrer : '/';
    window.location.replace(back);
  })();
  (function(){
    var flag = null;
    try { flag = sessionStorage.getItem('mdwOpen'); sessionStorage.removeItem('mdwOpen'); } catch(err){}
    if(flag) setTimeout(open, 260);
  })();

  /* ═══════════ FORM-INTERCEPT — elke product-form add ═══════════
     Formulieren met data-mdw-skip of data-mgp-own blijven met rust gelaten. */
  document.addEventListener('submit', function(e){
    var form = e.target;
    if(!form || !form.action) return;
    if(form.getAttribute('data-mdw-skip') === 'true' || form.getAttribute('data-mgp-own') === 'true') return;
    if(String(form.action).indexOf('/cart/add') === -1) return;

    e.preventDefault();
    var t = ++seq; busy(true);
    var btn = form.querySelector('[type="submit"]');
    if(btn) btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      body: new FormData(form),
      headers: {'Accept':'application/json','X-Requested-With':'XMLHttpRequest'},
      credentials: 'same-origin'
    })
    .then(function(r){ return r.json().then(function(j){ if(!r.ok) throw new Error(j.description || 'Sold out'); return j; }); })
    .then(function(){ return req('/cart.js'); })
    .then(function(c){ paint(c, t); open(); })
    .catch(function(err){ say(err && err.message ? err.message : 'Could not add to cart'); })
    .then(function(){ if(btn) btn.disabled = false; busy(false); });
  });

  /* ═══════════ EXTERNE ADDS — één draad, ook voor code die wij niet schreven ═══════════
     Elk /cart/add van een ander script (app, theme, custom buybox) triggert
     dezelfde refresh + open. Idempotent: we patchen maximaal één keer. */
  if(!window.__mdwHooked){
    window.__mdwHooked = true;
    var afterAdd = function(){ setTimeout(function(){ refresh().then(open); }, 60); };

    var _fetch = window.fetch;
    window.fetch = function(){
      var a = arguments;
      var u = (a[0] && a[0].url) ? a[0].url : a[0];
      var p = _fetch.apply(this, a);
      if(typeof u === 'string' && u.indexOf('/cart/add') > -1){
        p.then(function(r){ if(r && r.ok) afterAdd(); }).catch(function(){});
      }
      return p;
    };
    var _open = XMLHttpRequest.prototype.open, _send = XMLHttpRequest.prototype.send;
    XMLHttpRequest.prototype.open = function(m, u){
      this.__mdwAdd = (typeof u === 'string' && u.indexOf('/cart/add') > -1);
      return _open.apply(this, arguments);
    };
    XMLHttpRequest.prototype.send = function(){
      if(this.__mdwAdd) this.addEventListener('load', function(){
        if(this.status >= 200 && this.status < 300) afterAdd();
      });
      return _send.apply(this, arguments);
    };
  }

  /* ═══════════ PUBLIEKE API — 1:1 dezelfde draad als voorheen ═══════════ */
  window.MENTACart = {
    open:    open,
    close:   close,
    refresh: refresh,
    addItem: function(id, qty, arg){
      /* backwards-compat: oude signatuur addItem(id, qty, isFree) */
      var opts = (arg && typeof arg === 'object') ? arg : {};
      return addItem(id, qty, opts);
    },
    count:   function(){ return LAST ? LAST.item_count : 0; },
    state:   function(){ return LAST; }
  };

  /* ═══════════ BOOT ═══════════ */
  refresh();
  document.addEventListener('visibilitychange', function(){
    if(document.visibilityState === 'visible' && !drawer.classList.contains('on')) refresh();
  });
})();